// ════════════════════════════════════════════════════════════════════════════
// MONA Configurator — native Shopify cart + Cloudinary snapshot
// ════════════════════════════════════════════════════════════════════════════

const app = document.getElementById("mona-configurator-app");
if (!app || !window.MONA_CONFIG) throw new Error("MONA configurator could not initialize.");

const CONFIG  = window.MONA_CONFIG;
const PRICING = window.MONA_PRICING || {};
const STRUCT  = PRICING.structural || {};
const CELL = 80, LINE = 3, DEPTH = 80, MAX_W = 5, MAX_H = 5;

const CLOUDINARY = {
  cloudName: "djjskblqu",
  uploadPreset: "Mona_Configurator"
};

const MONA_LOGO_URL = "https://cdn.shopify.com/s/files/1/0799/5264/2301/files/Screenshot_2026-01-22_at_15.05.42.png?v=1769083565";

const isTurkish = (
  (document.documentElement.lang || "").toLowerCase().startsWith("tr") ||
  (window.Shopify?.locale || "").toLowerCase().startsWith("tr") ||
  (navigator.language || "").toLowerCase().startsWith("tr")
);
const currency = {
  code:       isTurkish ? "TRY" : "EUR",
  symbol:     isTurkish ? "₺"   : "€",
  eurTryRate: 40,
  ready:      false
};

async function fetchExchangeRate() {
  try {
    const res  = await fetch("https://open.er-api.com/v6/latest/EUR");
    const data = await res.json();
    if (data?.rates?.TRY) currency.eurTryRate = data.rates.TRY;
  } catch (e) {
    console.warn("Exchange rate fetch failed — using fallback rate.", e);
  }
  currency.ready = true;
  render(true);
}

function toDisplay(tryAmount) {
  return currency.code === "TRY" ? tryAmount : tryAmount / currency.eurTryRate;
}

const money = amt => {
  const num = Math.ceil(Number(amt || 0) / 10) * 10;
  return currency.code === "TRY"
    ? "₺\u202f" + num.toLocaleString("tr-TR")
    : "€\u202f"  + num.toLocaleString("de-DE");
};

const getDisplayPrice = tryAmount => toDisplay(Number(tryAmount || 0));

const $ = id => document.getElementById(id);
const els = {
  widthMinus: $("mona-width-minus"), widthPlus: $("mona-width-plus"), widthVal: $("mona-width-val"),
  heightMinus: $("mona-height-minus"), heightPlus: $("mona-height-plus"), heightVal: $("mona-height-val"),
  grid: $("mona-grid"), gridWrapper: $("mona-grid-wrapper"), library: $("mona-library"),
  status: $("mona-status"), addToCart: $("mona-add-to-cart-top"),
  openCustomize: $("mona-open-customize"), openPrice: $("mona-open-price"),
  rightPanelTitle: $("mona-right-panel-title"), rightPanelCustomize: $("mona-right-panel-customize"),
  rightPanelPrice: $("mona-right-panel-price"), priceBreakdown: $("mona-price-breakdown"),
  elementsList: $("mona-elements-list"), inspectorEmpty: $("mona-inspector-empty"),
  inspectorFields: $("mona-inspector-fields"), boxFinish: $("mona-box-finish"),
  knobGroup: $("mona-knob-group"), boxKnob: $("mona-box-knob"),
  rotateLeft: $("mona-rotate-left"), rotateRight: $("mona-rotate-right"),
  resetLayout: $("mona-reset-layout"),
  toolColumn: $("mona-tool-column")
};

const moduleDefs = (CONFIG.components || []).filter(i => i.enabled !== false && i.type === "module");
const FINISHES   = Array.isArray(CONFIG.finishes) ? CONFIG.finishes : [];
const KNOBS      = Array.isArray(CONFIG.knobs) && CONFIG.knobs.length
  ? CONFIG.knobs
  : [{ value: "none", label: "No knob", image: "" }];

let uidCounter = 1;
const state = {
  width: 4, height: 4, defaultFinish: "walnut", modules: [],
  removedVertical: {}, removedTop: {}, removedHorizontal: {}, leftTrim: {}, rightTrim: {},
  /* Tracks row-0 dividers that were auto-removed by the top-group cascade
     (so + can reverse only those, not user-removed dividers). */
  autoMergedTopDividers: {},
  selectedModuleId: null, rotX: -0.001, rotY: 0.001, showMeasurements: false, rightPanelMode: "customize"
};

const nextId            = () => `mona_mod_${uidCounter++}`;
const keyV              = (row, col) => `${row}_${col}`;
const setStatus         = msg => { if (els.status) els.status.textContent = msg || ""; };
const T                 = (key, fallback) => (window.MONA_T && window.MONA_T[key]) || fallback;
const getModuleDef      = id => moduleDefs.find(m => m.id === id) || null;
const getModuleById     = id => state.modules.find(m => m.id === id) || null;
const getSelectedModule = ()  => getModuleById(state.selectedModuleId);
const getFinishDef      = v => FINISHES.find(f => f.value === v) || FINISHES[0] || { value: "walnut", label: "Walnut", fallback: "#7b5537" };
const getKnobDef        = v => KNOBS.find(k => k.value === v)    || KNOBS[0]    || { value: "none", label: "No knob", image: "" };
const fallbackFinishColor = v => getFinishDef(v)?.fallback || "#7b5537";
const supportsFinish    = id => getModuleDef(id)?.supportsFinish !== false && !!getModuleDef(id);
const supportsKnob      = id => !!getModuleDef(id)?.supportsKnob;
const isBig2x2ModuleType = id => id === "closed_2x2";

function mk(tag, css, props = {}) {
  const el = document.createElement(tag);
  if (css) el.style.cssText = css;
  Object.assign(el, props);
  return el;
}

function countBoxesByType(typeId) { return state.modules.filter(m => m.type === typeId).length; }
function countRemovedDividers() { return Object.keys(state.removedVertical).filter(k => state.removedVertical[k]).length; }
function countRemovedTopSegments() { return Object.keys(state.removedTop).filter(k => state.removedTop[k]).length; }

function countRemovedHorizontalRails() {
  return Object.keys(state.removedHorizontal).filter(k => state.removedHorizontal[k]).length;
}

/* Count vertical posts that disappear because both adjacent columns
   have their rails removed at the same row */
function countRemovedVerticalPosts() {
  let count = 0;
  for (let col = 1; col < state.width; col++) {
    /* Top row */
    if (state.removedTop[`top_${col - 1}`] && state.removedTop[`top_${col}`]) count++;
    /* Inner rows */
    for (let row = 1; row < state.height; row++) {
      if (horizontalRailRemoved(row, col - 1) && horizontalRailRemoved(row, col)) count++;
    }
  }
  return count;
}

function computeStructuralQuantities() {
  const w = state.width, h = state.height;
  const closed2x2Count = countBoxesByType("closed_2x2");
  const open2x1Count   = countBoxesByType("open_2x1");
  const removedDivs    = countRemovedDividers();
  const removedTops    = countRemovedTopSegments();
  const removedHRails  = countRemovedHorizontalRails();
  const removedPosts   = countRemovedVerticalPosts();
  let uFrames     = (w + 1) * h - (closed2x2Count * 2) - (open2x1Count * 1) - removedDivs - removedPosts;
  let connectors  = 2 * w * (h + 2) - (closed2x2Count * 4) - removedTops - (removedHRails * 2);
  let shelfPanels = w * h - (closed2x2Count * 2) - removedHRails;
  const baseRects = w + 1;
  const feet      = 2 * (w + 1);
  return {
    uFrames:     Math.max(0, uFrames),
    connectors:  Math.max(0, connectors),
    shelfPanels: Math.max(0, shelfPanels),
    baseRects, feet
  };
}

function getStructuralTotalTRY() {
  const q = computeStructuralQuantities();
  return q.uFrames     * (STRUCT.uFrame?.price        || 0) +
         q.connectors  * (STRUCT.connector?.price     || 0) +
         q.baseRects   * (STRUCT.baseRectangle?.price || 0) +
         q.shelfPanels * (STRUCT.shelfPanel?.price    || 0) +
         q.feet        * (STRUCT.foot?.price          || 0);
}
function getBoxesTotalTRY() {
  return state.modules.reduce((t, m) => {
    const unitPrice = getModuleDef(m.type)?.price || 0;
    const multiplier = m.type === "wood_top" ? (m.w || 1) : 1;
    return t + unitPrice * multiplier;
  }, 0);
}
const getStructuralDisplayPrice = () => toDisplay(getStructuralTotalTRY());
const getBoxesDisplayPrice      = () => toDisplay(getBoxesTotalTRY());
const getConfigFeeTRY           = () => (window.MONA_CONFIG_PRODUCT && window.MONA_CONFIG_PRODUCT.price) || 0;
const getConfigFeeDisplayPrice  = () => toDisplay(getConfigFeeTRY());
const getTotalPrice             = () => getStructuralDisplayPrice() + getBoxesDisplayPrice() + getConfigFeeDisplayPrice();

function serializeBuildState() {
  return {
    w: state.width, h: state.height,
    rv: state.removedVertical, rt: state.removedTop,
    rh: state.removedHorizontal,
    am: state.autoMergedTopDividers,
    lt: state.leftTrim, rtr: state.rightTrim,
    df: state.defaultFinish,
    m: state.modules.map(m => ({
      t: m.type, r: m.row, c: m.col, w: m.w, h: m.h,
      f: m.finish || "", k: m.knob || "none",
      rt: m.removeTopShelf ? 1 : 0
    }))
  };
}
function encodeBuildState() {
  try { return btoa(unescape(encodeURIComponent(JSON.stringify(serializeBuildState())))); }
  catch (e) { console.warn("encode failed", e); return ""; }
}
function decodeBuildState(encoded) {
  try { return JSON.parse(decodeURIComponent(escape(atob(encoded)))); }
  catch (e) { console.warn("decode failed", e); return null; }
}
function applyBuildState(saved) {
  if (!saved) return;
  state.width  = Math.max(1, Math.min(MAX_W, saved.w || 4));
  state.height = Math.max(1, Math.min(MAX_H, saved.h || 4));
  state.removedVertical      = saved.rv || {};
  state.removedTop           = saved.rt || {};
  state.removedHorizontal    = saved.rh || {};
  state.autoMergedTopDividers = saved.am || {};
  state.leftTrim             = saved.lt || {};
  state.rightTrim            = saved.rtr || {};
  if (saved.df && FINISHES.some(f => f.value === saved.df)) state.defaultFinish = saved.df;
  state.modules = (saved.m || []).map(s => {
    const placed = {
      id: nextId(), type: s.t, row: s.r, col: s.c, w: s.w, h: s.h,
      finish: s.f || state.defaultFinish, knob: s.k || "none",
      removeTopShelf: !!s.rt
    };
    normalizeModuleOptions(placed);
    return placed;
  });
  clampDimensions();
}
function loadBuildStateFromURL() {
  try {
    const params = new URLSearchParams(window.location.search);
    const buildParam = params.get("build");
    if (!buildParam) return false;
    const decoded = decodeBuildState(buildParam);
    if (!decoded) return false;
    applyBuildState(decoded);
    return true;
  } catch (e) { console.warn("loadBuildStateFromURL failed", e); return false; }
}

function renderConfigToCanvas() {
  const SCALE = 1, PAD = 24, cw = state.width * CELL, ch = state.height * CELL;
  const canvas = document.createElement("canvas");
  canvas.width  = (cw + PAD * 2) * SCALE;
  canvas.height = (ch + PAD * 2) * SCALE;
  const ctx = canvas.getContext("2d");
  ctx.scale(SCALE, SCALE);
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, cw + PAD * 2, ch + PAD * 2);
  ctx.save();
  ctx.translate(PAD, PAD);
  const frameColor = CONFIG.frameColor || "#2b2b2b", localLine = 4;
  state.modules.forEach(m => {
    const def = getModuleDef(m.type);
    const x = m.col * CELL + 6, y = m.row * CELL + 6, w = m.w * CELL - 12, h = m.h * CELL - 12;
    ctx.fillStyle = fallbackFinishColor(m.finish || state.defaultFinish);
    ctx.beginPath();
    ctx.roundRect ? ctx.roundRect(x, y, w, h, 3) : ctx.rect(x, y, w, h);
    ctx.fill();
    if (supportsKnob(m.type) && m.knob !== "none") {
      const pos = def?.knobPosition || { x: 0.5, y: 0.5, size: 0.16 };
      const ks  = Math.max(8, Math.round(Math.min(w, h) * (pos.size || 0.16)));
      ctx.fillStyle = "#222"; ctx.beginPath();
      ctx.arc(x + w * (pos.x ?? 0.5), y + h * (pos.y ?? 0.5), ks / 2, 0, Math.PI * 2); ctx.fill();
    }
    ctx.fillStyle = "rgba(255,255,255,0.9)"; ctx.font = "bold 10px Arial";
    ctx.textAlign = "center"; ctx.textBaseline = "middle";
    ctx.fillText(def ? def.name : m.type, x + w / 2, y + h / 2 - 6);
    if (supportsFinish(m.type)) { ctx.font = "10px Arial"; ctx.fillText(getFinishDef(m.finish)?.label || "", x + w / 2, y + h / 2 + 8); }
  });
  ctx.fillStyle = frameColor;
  for (let row = 0; row <= state.height; row++)
    for (let col = 0; col < state.width; col++)
      if (row === 0 ? !state.removedTop[`top_${col}`] : true)
        ctx.fillRect(col * CELL, row * CELL - localLine / 2, CELL, localLine);
  for (let row = 0; row < state.height; row++) {
    const y = row * CELL;
    if (!state.leftTrim[row])  ctx.fillRect(-localLine / 2, y, localLine, CELL);
    for (let col = 0; col < state.width - 1; col++)
      if (!isVerticalDividerRemoved(row, col)) ctx.fillRect((col + 1) * CELL - localLine / 2, y, localLine, CELL);
    if (!state.rightTrim[row]) ctx.fillRect(state.width * CELL - localLine / 2, y, localLine, CELL);
  }
  ctx.restore();
  return canvas;
}

function canvasToBlob(canvas) { return new Promise(resolve => canvas.toBlob(resolve, "image/jpeg", 0.6)); }

function normalizeModuleOptions(module) {
  if (!module) return;
  if (!module.id) module.id = nextId();
  if (supportsFinish(module.type)) {
    if (!FINISHES.some(f => f.value === module.finish)) module.finish = state.defaultFinish;
  } else {
    module.finish = "";
  }
  module.knob = supportsKnob(module.type) && KNOBS.some(k => k.value === module.knob) ? module.knob : "none";
}

function createPlacedModule(typeId, row, col, width, height) {
  const placed = {
    id: nextId(), type: typeId, row, col, w: width, h: height,
    finish: supportsFinish(typeId) ? state.defaultFinish : "",
    knob: "yellow",
    removeTopShelf: false
  };
  normalizeModuleOptions(placed);
  return placed;
}

function resolveModuleAsset(def, face, finishValue, knobValue) {
  const fk = finishValue || state.defaultFinish;
  /* For the front face, check if there's a per-knob lookup first. */
  if (face === "front" && knobValue && def?.assets?.frontByKnob) {
    const byKnob = def.assets.frontByKnob[fk];
    if (byKnob && byKnob[knobValue]) return byKnob[knobValue];
  }
  const byFace = def?.assets?.[face];
  if (byFace && typeof byFace === "object" && byFace[fk]) return byFace[fk];
  if (fk === "walnut") {
    if (face === "front") return def?.image || "";
    if (face === "side")  return def?.imageSide || "";
    if (face === "top")   return def?.imageTop || "";
  }
  return "";
}

function createKnobOverlay(def, module, wPx, hPx) {
  if (!supportsKnob(module.type) || module.knob === "none") return null;
  const knob = getKnobDef(module.knob);
  if (!knob?.image) return null;
  const pos    = def?.knobPosition || { x: 0.5, y: 0.5, size: 0.16 };
  const sizePx = Math.max(12, Math.round(Math.min(wPx, hPx) * (pos.size || 0.16)));
  return mk("img", `position:absolute;width:${sizePx}px;height:${sizePx}px;
    left:${Math.round(wPx * (pos.x ?? 0.5) - sizePx / 2)}px;
    top:${Math.round(hPx * (pos.y ?? 0.5) - sizePx / 2)}px;
    z-index:20;pointer-events:none;object-fit:contain;`,
    { src: knob.image, alt: knob.label || "Knob", draggable: false });
}

function createSquareDragGhost(imgSrc, labelText) {
  const ghost = mk("div", `width:84px;height:84px;border-radius:10px;background:#fff;
    box-shadow:0 6px 18px rgba(0,0,0,.16);border:1px solid rgba(0,0,0,.08);
    display:flex;align-items:center;justify-content:center;overflow:hidden;
    position:absolute;left:-9999px;top:-9999px;`);
  if (imgSrc) {
    ghost.appendChild(mk("img", "width:100%;height:100%;object-fit:cover;", { src: imgSrc }));
  } else {
    Object.assign(ghost.style, { fontSize: "11px", color: "#666", textAlign: "center", padding: "8px" });
    ghost.textContent = labelText || "";
  }
  document.body.appendChild(ghost);
  return ghost;
}

function updateStepperDisplay() {
  if (els.widthVal)    els.widthVal.textContent  = String(state.width);
  if (els.heightVal)   els.heightVal.textContent = String(state.height);
  /* Disable the minus button if pressing it would result in total cells < 2 */
  if (els.widthMinus)  els.widthMinus.disabled   = state.width  <= 1 || (state.width  - 1) * state.height < 2;
  if (els.widthPlus)   els.widthPlus.disabled    = state.width  >= MAX_W;
  if (els.heightMinus) els.heightMinus.disabled  = state.height <= 1 || state.width * (state.height - 1) < 2;
  if (els.heightPlus)  els.heightPlus.disabled   = state.height >= MAX_H;
}

// ════════════════════════════════════════════════════════════════════════════
// RAIL / DIVIDER / COLUMN HELPERS
// ════════════════════════════════════════════════════════════════════════════

const topRailIntact = col => !state.removedTop[`top_${col}`];

/* Find the maximal "top group" containing col — the longest run of adjacent
   columns that:
   - All share the same top-rail state (all removed or all intact)
   - Are connected at row 0 by removed vertical dividers between each adjacent pair
   Used to render a single merged top X/+ button per group, and to apply the
   X click to all cols in the group at once. */
function getTopGroup(col) {
  const isRemoved = !!state.removedTop[`top_${col}`];
  let startCol = col;
  while (startCol > 0 &&
         state.removedVertical[keyV(0, startCol - 1)] &&
         !!state.removedTop[`top_${startCol - 1}`] === isRemoved) {
    startCol--;
  }
  let endCol = col;
  while (endCol < state.width - 1 &&
         state.removedVertical[keyV(0, endCol)] &&
         !!state.removedTop[`top_${endCol + 1}`] === isRemoved) {
    endCol++;
  }
  return { startCol, endCol };
}

/* Reconcile auto-merged dividers after any change to removedTop:
   an auto-merged row-0 divider is only valid when BOTH adjacent columns are
   still shortened. If one side gets restored (e.g., box placed at row 0),
   undo the auto-merge to keep the visual state coherent. */
function reconcileAutoMergedTopDividers() {
  Object.keys(state.autoMergedTopDividers).forEach(k => {
    const [r, c] = k.split("_").map(Number);
    if (r !== 0) {
      delete state.autoMergedTopDividers[k];
      return;
    }
    if (!state.removedTop[`top_${c}`] || !state.removedTop[`top_${c + 1}`]) {
      delete state.removedVertical[k];
      delete state.autoMergedTopDividers[k];
    }
  });
}

/* Check if horizontal rail at row r, col c is removed.
   row=1 means rail between row 0 and row 1.
   Bottom rail (row=state.height) cannot be removed. */
const horizontalRailKey = (row, col) => `h_${row}_${col}`;
const horizontalRailRemoved = (row, col) => !!state.removedHorizontal[horizontalRailKey(row, col)];

/* Is the rail at row r intact in column c?
   Row 0 = top rail (state.removedTop), rows 1..h-1 = inner (removedHorizontal),
   row h = bottom (always intact). */
function railIntactAt(r, c) {
  if (r === 0) return !state.removedTop[`top_${c}`];
  if (r >= state.height) return true;
  return !horizontalRailRemoved(r, c);
}

/* Does column c have a "cell" present at row r?
   A cell exists at row r if there's an enclosing "ceiling" — at least one
   intact rail at any row from 0 through r. The floor (row state.height) is
   always intact, so the bottom enclosure is always satisfied. */
function columnHasCellAtRow(c, r) {
  for (let rr = 0; rr <= r; rr++) {
    if (railIntactAt(rr, c)) return true;
  }
  return false;
}

/* The rail above this row is gone — meaning we can remove this rail too. */
function isRailAboveRemoved(row, col) {
  if (row === 1) return !topRailIntact(col);
  return horizontalRailRemoved(row - 1, col);
}

/* Removing rail at (row, col):
   - "Shortening" if there's a continuous removal chain from the top rail
     down through every rail above this one. Requires top rail to be removed.
   - "Tall opening" otherwise. */
function isShorteningRemoval(row, col) {
  if (!state.removedTop[`top_${col}`]) return false;
  for (let r = 1; r < row; r++) {
    if (!horizontalRailRemoved(r, col)) return false;
  }
  return true;
}

/* Does column c already have a tall opening (an inner rail removed where the
   rail above it is intact)? */
function columnHasTallOpening(col) {
  for (let r = 1; r < state.height; r++) {
    if (!horizontalRailRemoved(r, col)) continue;
    if (!isRailAboveRemoved(r, col)) return true;
  }
  return false;
}
/* A column is "effectively full-height" if its top rail is intact. */
function isColumnFullHeight(col) {
  return !state.removedTop[`top_${col}`];
}
/* ── Lateral-stability rule ──────────────────────────────────────────────
   Compute each column's effective HEIGHT (in rows) from a hypothetical
   removedTop/removedHorizontal pair. A full column = state.height; a column
   shortened so its top surface is at row N has height state.height - N. */
function columnHeightFrom(col, rmTop, rmHoriz) {
  if (!rmTop[`top_${col}`]) return state.height;          /* full height */
  /* Top removed: surface sits at the first row whose inner rail is intact.
     With no inner rails removed, that's row 1 → height = state.height - 1. */
  for (let r = 1; r < state.height; r++) {
    if (!rmHoriz[`h_${r}_${col}`]) return state.height - r; /* surface at row r */
  }
  return 0; /* every inner rail removed too — fully shortened away */
}

/* A column is unstable if it stands 2+ rows TALLER than every one of its
   immediate neighbors. It needs at least one neighbor within 1 row of its
   own height for lateral support. Returns true if the layout is OK. */
function layoutSatisfiesStability(rmTop, rmHoriz) {
  const heights = [];
  for (let c = 0; c < state.width; c++) heights.push(columnHeightFrom(c, rmTop, rmHoriz));
  for (let c = 0; c < state.width; c++) {
    const h = heights[c];
    let hasSupport = false;
    if (c > 0 && Math.abs(heights[c - 1] - h) <= 1) hasSupport = true;
    if (c < state.width - 1 && Math.abs(heights[c + 1] - h) <= 1) hasSupport = true;
    /* A single-column unit has no neighbors — always allowed. */
    if (state.width === 1) hasSupport = true;
    /* Only TALL-standing columns need support. A column that is shorter than
       (or within 1 of) every neighbor is fine. It's unstable only if it's
       2+ taller than ALL neighbors. */
    const tallerThanAllNeighbors =
      (c === 0 || h - heights[c - 1] >= 2) &&
      (c === state.width - 1 || h - heights[c + 1] >= 2);
    if (tallerThanAllNeighbors && !hasSupport) return false;
  }
  return true;
}

/* Returns the row index of the visible top surface of column `col`.
   - Full-height column: 0
   - Shortened to row N (top rail removed + inner rails removed for rows 1..N-1,
     intact at row N): N
   - No surface at all (every rail removed top to bottom): null
   This is where a wood top can sit. */
function getColumnTopSurfaceRow(col) {
  if (!state.removedTop[`top_${col}`]) return 0;
  for (let r = 1; r < state.height; r++) {
    if (!horizontalRailRemoved(r, col)) return r;
  }
  return null;
}

/* Count of columns OTHER THAN excludeCol that are at full height. */
function fullHeightOtherColumnsCount(excludeCol) {
  let count = 0;
  for (let c = 0; c < state.width; c++) {
    if (c === excludeCol) continue;
    if (isColumnFullHeight(c)) count++;
  }
  return count;
}

/* Is there an open_2x1 module spanning the boundary between c1 and c2 at row r? */
function open2x1BridgesAt(c1, c2, r) {
  return state.modules.some(m =>
    m.type === "open_2x1" &&
    m.col === Math.min(c1, c2) &&
    m.col + m.w > Math.max(c1, c2) &&
    m.row <= r && r < m.row + m.h
  );
}

function firstAvailableWoodTopCol() {
  for (let col = 0; col < state.width; col++) {
    const surface = getColumnTopSurfaceRow(col);
    if (surface === null) continue;
    if (state.modules.some(m => m.type === "wood_top" && col >= m.col && col < m.col + m.w)) continue;
    return col;
  }
  return -1;
}

/* Wood top can expand into the next column only if that column has the
   SAME top surface row as the current wood top, and no other wood top
   already sits there. */
const canExpandWoodTop = i => {
  const m = state.modules[i];
  if (!m) return false;
  const nc = m.col + m.w;
  if (nc >= state.width) return false;
  const neighborSurface = getColumnTopSurfaceRow(nc);
  if (neighborSurface !== m.row) return false;
  return !state.modules.some((o, j) => j !== i && o.type === "wood_top" && nc >= o.col && nc < o.col + o.w);
};
const canShrinkWoodTop = i => !!state.modules[i] && state.modules[i].w > 1;

const satisfiesPlacementRules = (typeId, row) => isBig2x2ModuleType(typeId) ? row === state.height - 2 : true;

function canPlaceAt(row, col, w, h, ignoreIndex = -1, typeId = null) {
  if (row < 0 || col < 0 || row + h > state.height || col + w > state.width) return false;
  if (!satisfiesPlacementRules(typeId, row)) return false;
  /* Check no collision with existing modules */
  const collides = state.modules.some((m, i) => {
    if (i === ignoreIndex || m.type === "wood_top") return false;
    return !(col + w <= m.col || m.col + m.w <= col || row + h <= m.row || m.row + m.h <= row);
  });
  if (collides) return false;
  /* Stacking alignment rule: when two boxes are stacked AND the rail between
     them is removed (so the boxes physically touch), they must have the exact
     same column range. When the rail is intact, the rail acts as a structural
     separator — boxes of any size can be stacked freely. */
  const railIntactBetween = (railRow, c1, c2) => {
    /* Check rail at railRow is intact across cols c1..c2-1 */
    for (let c = c1; c < c2; c++) {
      if (railRow === 0) {
        if (state.removedTop[`top_${c}`]) return false;
      } else {
        if (horizontalRailRemoved(railRow, c)) return false;
      }
    }
    return true;
  };
  const boxBottom = row + h;
  const boxBelow = state.modules.find((m, i) => {
    if (i === ignoreIndex || m.type === "wood_top") return false;
    if (m.row !== boxBottom) return false;
    return !(col + w <= m.col || m.col + m.w <= col);
  });
  if (boxBelow && !railIntactBetween(boxBottom, Math.min(col, boxBelow.col), Math.max(col + w, boxBelow.col + boxBelow.w))) {
    /* Rail between us and the box below is gone — must have exact alignment */
    if (boxBelow.col !== col || boxBelow.w !== w) return false;
  }
  const boxAbove = state.modules.find((m, i) => {
    if (i === ignoreIndex || m.type === "wood_top") return false;
    if (m.row + m.h !== row) return false;
    return !(col + w <= m.col || m.col + m.w <= col);
  });
  if (boxAbove && !railIntactBetween(row, Math.min(col, boxAbove.col), Math.max(col + w, boxAbove.col + boxAbove.w))) {
    if (boxAbove.col !== col || boxAbove.w !== w) return false;
  }
  return true;
}

const moduleSpansVerticalDivider = (m, row, col) =>
  m && m.type !== "wood_top" &&
  m.col < col + 1 && m.col + m.w > col + 1 &&
  row >= Math.floor(m.row) && row < Math.ceil(m.row + m.h);

const moduleSpansHorizontalRail = (m, row, col) =>
  m && m.type !== "wood_top" &&
  m.col <= col && col < m.col + m.w &&
  m.row < row && row < m.row + m.h;

const isVerticalDividerRemoved = (row, col) =>
  !!state.removedVertical[keyV(row, col)] || state.modules.some(m => moduleSpansVerticalDivider(m, row, col));

const removedCountInRow = (row, src = state.removedVertical) => {
  const manualCount = Object.keys(src).filter(k => {
    const [r, c] = k.split("_").map(Number);
    if (r !== row || !src[k]) return false;
    /* At row 0: dividers between two shortened columns don't count toward
       the per-row limit (auto-managed as part of merged-top behavior). */
    if (r === 0 && state.removedTop[`top_${c}`] && state.removedTop[`top_${c + 1}`]) {
      return false;
    }
    return true;
  }).length;
  /* 2-wide (or wider) modules occupying this row also count as a divider removal
     for each internal divider they span. */
  let moduleSpanCount = 0;
  state.modules.forEach(m => {
    if (m.type === "wood_top") return;
    if (m.w < 2) return;
    if (row >= Math.floor(m.row) && row < Math.ceil(m.row + m.h)) {
      moduleSpanCount += (m.w - 1);
    }
  });
  return manualCount + moduleSpanCount;
};

const removedCountInRowUnderPanel = (row, pCol, pW, src = state.removedVertical) => {
  const manualCount = Object.keys(src).filter(k => {
    const [r, c] = k.split("_").map(Number);
    return r === row && src[k] && c >= pCol - 1 && c < pCol + pW - 1;
  }).length;
  let moduleSpanCount = 0;
  state.modules.forEach(m => {
    if (m.type === "wood_top") return;
    if (m.w < 2) return;
    if (row < Math.floor(m.row) || row >= Math.ceil(m.row + m.h)) return;
    for (let c = m.col; c < m.col + m.w - 1; c++) {
      if (c >= pCol - 1 && c < pCol + pW - 1) moduleSpanCount++;
    }
  });
  return manualCount + moduleSpanCount;
};

function canKeepManualRemovedDivider(row, col, workingMap) {
  if (col < 0 || col >= state.width - 1) return false;
  /* At row 0: dividers between two shortened columns are always kept
     (auto-managed as part of merged-top behavior, not subject to the limit). */
  if (row === 0 && state.removedTop[`top_${col}`] && state.removedTop[`top_${col + 1}`]) {
    return true;
  }
  if (row === state.height - 1) return state.width > 3 && removedCountInRow(row, workingMap) < 1;
  const maxAllowed = state.width === 6 ? 2 : 1;
  if (removedCountInRow(row, workingMap) >= maxAllowed) return false;
  if (state.width === 6 && (workingMap[keyV(row, col - 1)] || workingMap[keyV(row, col + 1)])) return false;
  return true;
}

function normalizeManualDividerState() {
  const next = {};
  Object.keys(state.removedVertical)
    .filter(k => state.removedVertical[k])
    .map(k => { const [row, col] = k.split("_").map(Number); return { row, col }; })
    .filter(({ row, col }) => row >= 0 && row < state.height && col >= 0 && col < state.width - 1)
    .sort((a, b) => (a.row - b.row) || (a.col - b.col))
    .forEach(({ row, col }) => { if (canKeepManualRemovedDivider(row, col, next)) next[keyV(row, col)] = true; });
  state.removedVertical = next;
  /* Drop tracking entries for dividers that no longer exist */
  Object.keys(state.autoMergedTopDividers).forEach(k => {
    if (!state.removedVertical[k]) delete state.autoMergedTopDividers[k];
  });
}

function normalizeModulesAfterResize() {
  state.modules = state.modules.filter((m, i) => canPlaceAt(m.row, m.col, m.w, m.h, i, m.type));
  state.modules.forEach(normalizeModuleOptions);
  if (state.selectedModuleId && !getModuleById(state.selectedModuleId))
    state.selectedModuleId = state.modules[0]?.id || null;
}

function clampDimensions() {
  state.width  = Math.max(1, Math.min(MAX_W, state.width));
  state.height = Math.max(1, Math.min(MAX_H, state.height));
  /* Enforce minimum 2 total cells — bump height up if needed */
  if (state.width * state.height < 2) {
    if (state.width >= 1) state.height = Math.max(2, state.height);
    else state.width = 2;
  }
  Object.keys(state.removedVertical).forEach(k => {
    const [row, col] = k.split("_").map(Number);
    if (row >= state.height || col >= state.width - 1) delete state.removedVertical[k];
  });
  Object.keys(state.removedTop).forEach(k => {
    if (Number(String(k).replace("top_", "")) >= state.width) delete state.removedTop[k];
  });
  Object.keys(state.removedHorizontal).forEach(k => {
    const [, row, col] = k.split("_").map(Number);
    if (row >= state.height || col >= state.width) delete state.removedHorizontal[k];
  });
  Object.keys(state.leftTrim).forEach(k  => { if (Number(k) >= state.height) delete state.leftTrim[k]; });
  Object.keys(state.rightTrim).forEach(k => { if (Number(k) >= state.height) delete state.rightTrim[k]; });
  Object.keys(state.autoMergedTopDividers).forEach(k => {
    const [, col] = k.split("_").map(Number);
    if (col >= state.width - 1) delete state.autoMergedTopDividers[k];
  });
  normalizeModulesAfterResize();
  normalizeManualDividerState();
  reconcileAutoMergedTopDividers();
  updateStepperDisplay();
}

function restoreTopRailsAround(row, col, width) {
  /* Restore the top rail for every column the box spans (only when box touches row 0) */
  if (row === 0) {
    for (let c = col; c < col + width; c++) {
      delete state.removedTop[`top_${c}`];
      if (c === 0)               delete state.leftTrim[0];
      if (c === state.width - 1) delete state.rightTrim[0];
    }
    reconcileAutoMergedTopDividers();
  }
}

/* Restore inner horizontal rails needed to support a box placed at row r, col c. */
function restoreRailsForBox(row, col, width, height) {
  const topRailRow = Math.floor(row);
  const boxBottom  = Math.ceil(row + height);
  for (let c = col; c < col + width; c++) {
    if (topRailRow === 0) {
      delete state.removedTop[`top_${c}`];
      if (c === 0)               delete state.leftTrim[0];
      if (c === state.width - 1) delete state.rightTrim[0];
    } else {
      delete state.removedHorizontal[horizontalRailKey(topRailRow, c)];
    }
    for (let r = boxBottom; r <= state.height - 1; r++) {
      delete state.removedHorizontal[horizontalRailKey(r, c)];
    }
  }
  if (topRailRow === 0) reconcileAutoMergedTopDividers();
}

function restoreDividersAround(module) {
  const startRow = Math.floor(module.row);
  const endRow   = Math.ceil(module.row + module.h) - 1;
  const startCol = module.col - 1;
  const endCol   = module.col + module.w - 1;
  for (let r = startRow; r <= endRow; r++)
    for (let c = startCol; c <= endCol; c++)
      if (c >= 0 && c < state.width - 1) {
        delete state.removedVertical[keyV(r, c)];
        delete state.autoMergedTopDividers[keyV(r, c)];
      }

  /* If this module is wide (w >= 2), restore ALL dividers below the module's
     bottom edge for each internal divider the module spans, all the way down
     to the floor. Unless another wide module at that row covers that divider. */
  if (module.w >= 2 && module.type !== "wood_top") {
    const startRowBelow = Math.ceil(module.row + module.h);
    for (let r = startRowBelow; r < state.height; r++) {
      for (let c = module.col; c < module.col + module.w - 1; c++) {
        const dividerKey = keyV(r, c);
        if (!state.removedVertical[dividerKey]) continue;
        const coveredByOther = state.modules.some(m =>
          m !== module &&
          m.type !== "wood_top" &&
          m.w >= 2 &&
          r >= Math.floor(m.row) && r < Math.ceil(m.row + m.h) &&
          c >= m.col && c < m.col + m.w - 1
        );
        if (!coveredByOther) {
          delete state.removedVertical[dividerKey];
          delete state.autoMergedTopDividers[dividerKey];
        }
      }
    }
  }
}

function selectModule(id, silent = false) {
  state.selectedModuleId = id || null;
  setRightPanelMode("customize");
  renderInspector();
  renderElementsList();
  renderGrid();
  if (!silent && id) setStatus(T("status_box_selected", "Box selected."));
}

function clearSelection() {
  state.selectedModuleId = null;
  document.querySelectorAll('.mona-move-hint').forEach(el => el.remove());
  renderInspector();
  renderElementsList();
}

function addModule(typeId, row, col) {
  const def = getModuleDef(typeId);
  if (!def) return;
  /* Auto-snap 2x2 to the bottom-anchored row. The 2x2 always occupies the
     bottom two rows. If the user drops it at any row from the bottom row up,
     snap it to row = height - 2 so it fits. */
  if (isBig2x2ModuleType(typeId)) {
    row = state.height - 2;
  }
  if (typeId === "wood_top") {
    let startCol = -1;
    let surfaceRow = null;
    if (typeof col === "number" && col >= 0 && col < state.width) {
      surfaceRow = getColumnTopSurfaceRow(col);
      const colIsValid = surfaceRow !== null &&
        !state.modules.some(m => m.type === "wood_top" && col >= m.col && col < m.col + m.w);
      if (colIsValid) startCol = col;
    }
    if (startCol === -1) {
      startCol = firstAvailableWoodTopCol();
      if (startCol !== -1) surfaceRow = getColumnTopSurfaceRow(startCol);
    }
    if (startCol === -1 || surfaceRow === null) { setStatus(T("status_wood_top_no_space", "No available space for Wood Top.")); return; }

    /* Merge only with neighbors at the same surface row. */
    const leftNeighbor = state.modules.find(m =>
      m.type === "wood_top" && m.col + m.w === startCol && m.row === surfaceRow
    );
    const rightNeighbor = state.modules.find(m =>
      m.type === "wood_top" && m.col === startCol + 1 && m.row === surfaceRow
    );

    if (leftNeighbor && rightNeighbor) {
      leftNeighbor.w = leftNeighbor.w + 1 + rightNeighbor.w;
      const rightIdx = state.modules.indexOf(rightNeighbor);
      state.modules.splice(rightIdx, 1);
      state.selectedModuleId = leftNeighbor.id;
    } else if (leftNeighbor) {
      leftNeighbor.w++;
      state.selectedModuleId = leftNeighbor.id;
    } else if (rightNeighbor) {
      rightNeighbor.col--;
      rightNeighbor.w++;
      state.selectedModuleId = rightNeighbor.id;
    } else {
      const m = createPlacedModule("wood_top", surfaceRow, startCol, 1, 1);
      state.modules.push(m);
      state.selectedModuleId = m.id;
    }

    normalizeManualDividerState();
    setStatus(T("status_wood_top_added", "Wood Top added."));
    render();
    return;
  }
  if (!canPlaceAt(row, col, def.width, def.height, -1, def.id)) {
    setStatus(isBig2x2ModuleType(def.id) ? T("status_2x2_bottom_only", "The 2x2 box can only sit on the bottom two rows.") : T("status_box_no_fit", "That box does not fit there."));
    return;
  }
  restoreTopRailsAround(row, col, def.width);
  restoreRailsForBox(row, col, def.width, def.height);
  const m = createPlacedModule(def.id, row, col, def.width, def.height);
  restoreDividersAround(m);
  state.modules.push(m);
  state.selectedModuleId = m.id;
  normalizeManualDividerState();
  setStatus((T("status_box_added", "{{ name }} added.")).replace("{{ name }}", def.name));
  render();
}

function moveModule(index, row, col) {
  const module = state.modules[index];
  if (!module) return;
  /* Auto-snap 2x2 to bottom-anchored row, even if the user drags it to the bottom row. */
  if (isBig2x2ModuleType(module.type)) {
    row = state.height - 2;
  }
  if (!canPlaceAt(row, col, module.w, module.h, index, module.type)) {
    setStatus(isBig2x2ModuleType(module.type) ? T("status_2x2_bottom_only", "The 2x2 box can only sit on the bottom two rows.") : T("status_box_no_fit", "That box does not fit there."));
    return;
  }
  restoreTopRailsAround(module.row, module.col, module.w);
  module.row = row; module.col = col;
  restoreTopRailsAround(row, col, module.w);
  restoreRailsForBox(row, col, module.w, module.h);
  restoreDividersAround(module);
  normalizeManualDividerState();
  setStatus(T("status_box_moved", "Box moved."));
  render();
}

function canToggleVerticalDivider(row, col) {
  if (col < 0 || col >= state.width - 1) return false;
  if (state.removedVertical[keyV(row, col)]) return true;

  /* Structural rule: a wide opening (created by removing this divider) cannot
     exist directly UNDER a TALL OPENING in either of the two columns it joins,
     unless an open_2x1 box sits at this row to bridge it.
     "Tall opening" means an inner rail removed where the rail above is intact —
     i.e., a real merged 40×80 cell hanging over this row. Shortenings (top
     rail removed + chain) don't count: the column ends, there's nothing
     overhanging. */
  const colHasTallOpeningAtOrAbove = (c, r) => {
    for (let rk = 1; rk <= r; rk++) {
      if (!horizontalRailRemoved(rk, c)) continue;
      /* This rail is removed. Is it a tall opening (rail above intact)
         or part of a shortening chain (rail above also removed)? */
      const aboveRemoved = (rk === 1)
        ? !!state.removedTop[`top_${c}`]
        : horizontalRailRemoved(rk - 1, c);
      if (!aboveRemoved) return true;
    }
    return false;
  };

  if (colHasTallOpeningAtOrAbove(col, row) || colHasTallOpeningAtOrAbove(col + 1, row)) {
    if (!open2x1BridgesAt(col, col + 1, row)) return false;
  }

  /* Bottom row has its own constraint: only allowed when width > 3, and only
     one removal in the bottom row total. Don't return early though — still
     fall through to the stacking check below so order doesn't matter. */
  if (row === state.height - 1) {
    if (state.width <= 3 || removedCountInRow(row) >= 1) return false;
  } else {
    const maxAllowed = state.width === 6 ? 2 : 1;
    if (removedCountInRow(row) >= maxAllowed) return false;
    if (state.width === 6 && (state.removedVertical[keyV(row, col - 1)] || state.removedVertical[keyV(row, col + 1)])) return false;
  }
  /* When height > 3, no two dividers can be stacked vertically at the same
     col-boundary in adjacent rows. Counts both manual removals and auto-merged
     top dividers — visually they're both "no divider here", and stacking two
     directly produces an unsupported wide vertical opening. */
  if (state.height > 3) {
    if (state.removedVertical[keyV(row - 1, col)] || state.removedVertical[keyV(row + 1, col)]) {
      return false;
    }
  }
  return true;
}

function removeModulesCrossingVerticalDivider(row, col) {
  state.modules = state.modules.filter(m => !moduleSpansVerticalDivider(m, row, col));
  if (state.selectedModuleId && !getModuleById(state.selectedModuleId))
    state.selectedModuleId = state.modules[0]?.id || null;
}

function toggleVerticalDivider(row, col) {
  if (!canToggleVerticalDivider(row, col)) { setStatus(T("status_divider_limit", "Only one internal divider per row. Top row unlimited.")); return; }
  const key = keyV(row, col);
  if (state.removedVertical[key]) {
    delete state.removedVertical[key];
    delete state.autoMergedTopDividers[key];
    setStatus(T("status_divider_restored", "Divider restored."));
  } else {
    removeModulesCrossingVerticalDivider(row, col);
    state.removedVertical[key] = true;
    normalizeModulesAfterResize();
    setStatus(T("status_divider_removed", "Divider removed."));
  }
  normalizeManualDividerState();
  render();
}

function toggleTopSegment(col) {
  /* Operates on the entire "top group" containing col — adjacent columns
     connected at row 0 by removed dividers, with the same top-rail state. */
  const group = getTopGroup(col);
  const removing = !state.removedTop[`top_${group.startCol}`];

  if (removing) {
    /* Don't allow if no other column would remain at full height after
       shortening every column in the group. */
    let othersFullHeight = 0;
    for (let c = 0; c < state.width; c++) {
      if (c >= group.startCol && c <= group.endCol) continue;
      if (isColumnFullHeight(c)) othersFullHeight++;
    }
    if (othersFullHeight === 0) {
      setStatus(T("status_full_height_required", "At least one column must remain at full height."));
      return;
    }
    /* Lateral-stability: simulate shortening this group to the bottom-most
       surface it would reach, and reject if it leaves a tall column
       unsupported. A top-shortened column with no inner-rail chain becomes
       height 0 (surface row = state.height); but in practice top shortening
       only removes the top rail, so simulate height as if surface = row of
       first intact inner rail. We approximate the post-toggle removedTop. */
    {
      const simTop = Object.assign({}, state.removedTop);
      for (let c = group.startCol; c <= group.endCol; c++) simTop[`top_${c}`] = true;
      if (!layoutSatisfiesStability(simTop, state.removedHorizontal)) {
        setStatus(T("status_box_no_fit", "A taller column needs an adjacent column within one step in height."));
        return;
      }
    }
    /* Rule: removing the top rail cannot expose a horizontal opening at row 0
       on a side that's outside the group being shortened. A wide opening
       fully contained within the group disappears cleanly along with both
       columns above it, so it's fine. */
    for (let c = group.startCol; c <= group.endCol; c++) {
      const leftKey  = keyV(0, c - 1);
      const rightKey = keyV(0, c);
      /* Left side: divider between (c-1) and c is removed, AND (c-1) is
         outside the group (otherwise both sides are being shortened together) */
      const leftDividerExposes = (c - 1 >= 0)
        && (c - 1 < group.startCol)
        && !!state.removedVertical[leftKey]
        && !state.autoMergedTopDividers[leftKey];
      /* Right side: divider between c and (c+1) is removed, AND (c+1) is
         outside the group */
      const rightDividerExposes = (c < state.width - 1)
        && (c + 1 > group.endCol)
        && !!state.removedVertical[rightKey]
        && !state.autoMergedTopDividers[rightKey];
      if (leftDividerExposes || rightDividerExposes) {
        setStatus("Cannot shorten a column above a wide opening — the opening would float.");
        return;
      }
    }
  }

  /* Apply the toggle to every column in the group */
  for (let c = group.startCol; c <= group.endCol; c++) {
    state.removedTop[`top_${c}`] = removing;
    if (c === 0)               state.leftTrim[0]  = removing;
    if (c === state.width - 1) state.rightTrim[0] = removing;
    /* When restoring a top, also restore the entire shortening chain below it. */
    if (!removing) {
      for (let r = 1; r < state.height; r++) {
        if (!horizontalRailRemoved(r, c)) break;
        delete state.removedHorizontal[horizontalRailKey(r, c)];
      }
    }
  }

  if (removing) {
    /* Cascade: if the immediate neighbor outside the group is also shortened,
       auto-remove the row-0 divider between them to merge into one group.
       Track auto-additions so + can reverse only those (not user-removed dividers). */
    const tryAutoMerge = (k) => {
      if (!state.removedVertical[k]) {
        state.removedVertical[k] = true;
        state.autoMergedTopDividers[k] = true;
      }
    };
    if (group.startCol > 0 && state.removedTop[`top_${group.startCol - 1}`]) {
      tryAutoMerge(keyV(0, group.startCol - 1));
    }
    if (group.endCol < state.width - 1 && state.removedTop[`top_${group.endCol + 1}`]) {
      tryAutoMerge(keyV(0, group.endCol));
    }
  } else {
    /* Reverse the cascade: undo only the auto-added merge dividers within
       the just-restored group. Manually-removed dividers stay as the user set them. */
    for (let c = group.startCol; c < group.endCol; c++) {
      const k = keyV(0, c);
      if (state.autoMergedTopDividers[k]) {
        delete state.removedVertical[k];
        delete state.autoMergedTopDividers[k];
      }
    }
  }
  render();
}

// ════════════════════════════════════════════════════════════════════════════
// INNER RAIL REMOVAL — VALIDATION (used by both visibility check and click handler)
// ════════════════════════════════════════════════════════════════════════════

/* Returns null if the rail at (row, col) can be removed; otherwise returns
   the reason string for setStatus. */
function validateInnerRailRemoval(row, col) {
  const isShortening = isShorteningRemoval(row, col);
  /* Rule 1: only one TALL OPENING per column. Shortenings always allowed. */
  if (!isShortening && columnHasTallOpening(col)) {
    return "Only one tall opening allowed per column.";
  }
  /* Rule 2: at least one column must remain at full height. */
  if (fullHeightOtherColumnsCount(col) === 0) {
    return "At least one column must remain at full height.";
  }
  /* Rule 3: a tall opening in this col cannot sit next to a tall opening in
     an adjacent col at the SAME EXACT row pair, unless an open_2x1 bridges
     the wide opening. Offset tall openings (different row pairs) in adjacent
     columns are allowed. Only triggers if WE are creating a tall opening
     (not shortening). */
  if (!isShortening) {
    const neighborHasTallAtSameRow = (c) => {
      if (c < 0 || c >= state.width) return false;
      if (!horizontalRailRemoved(row, c)) return false;
      const railAboveIntact = (row === 1)
        ? !state.removedTop[`top_${c}`]
        : !horizontalRailRemoved(row - 1, c);
      return railAboveIntact;
    };
    if (neighborHasTallAtSameRow(col - 1) && !open2x1BridgesAt(col - 1, col, row - 1)) {
      return "Cannot create wide opening here without a 2x1 open box bridging it.";
    }
    if (neighborHasTallAtSameRow(col + 1) && !open2x1BridgesAt(col, col + 1, row - 1)) {
      return "Cannot create wide opening here without a 2x1 open box bridging it.";
    }
  }
  /* Rule 4: tall cell created by this removal (rows row-1 and row) cannot
     sit above a removed vertical divider, unless an open_2x1 bridges it.
     Only applies when CREATING a tall opening. Shortenings extend a column
     downward — there's no tall cell hanging over a removed divider. */
  if (!isShortening) {
    for (const r of [row - 1, row]) {
      const dividerLeftRemoved  = (col - 1 >= 0 && col - 1 < state.width - 1) ? !!state.removedVertical[keyV(r, col - 1)] : false;
      const dividerRightRemoved = (col >= 0 && col < state.width - 1)         ? !!state.removedVertical[keyV(r, col)]     : false;
      if (dividerLeftRemoved  && !open2x1BridgesAt(col - 1, col, r)) {
        return "Cannot create tall opening above a removed divider without a 2x1 open box.";
      }
      if (dividerRightRemoved && !open2x1BridgesAt(col, col + 1, r)) {
        return "Cannot create tall opening above a removed divider without a 2x1 open box.";
      }
    }
  }
  /* Rule 5: A tall opening cannot sit directly below a wide box (w >= 2).
     The cell immediately below a wide box must remain a normal 40x40 cell
     with rails intact. Exception: not applicable here — we are creating a
     tall opening, not stacking another wide box, so the exception (another
     wide box directly underneath) cannot apply to this action. */
  if (!isShortening) {
    const tallTopRow = row - 1;
    const wideBoxAbove = state.modules.find(m =>
      m.type !== "wood_top" &&
      m.w >= 2 &&
      Math.ceil(m.row + m.h) === tallTopRow &&
      col >= m.col && col < m.col + m.w
    );
    if (wideBoxAbove) {
      return "Cannot create a tall opening directly below a wide box.";
    }
  }
  /* Rule 6: removing this rail cannot expose a horizontal opening (wide
     opening created by a removed vertical divider). The rail at (row, col)
     is the TOP edge of cell at row=row, col=col. If a vertical divider is
     removed at (row, col-1) or (row, col), then the cell at (row, col)
     is part of a wide opening — and removing its top rail would leave the
     opening hanging from nothing on the col side. */
  const dividerLeftRemoved = (col - 1 >= 0) ? !!state.removedVertical[keyV(row, col - 1)] : false;
  const dividerRightRemoved = (col < state.width - 1) ? !!state.removedVertical[keyV(row, col)] : false;
  if (dividerLeftRemoved || dividerRightRemoved) {
    return "Cannot shorten a column above a wide opening — the opening would float.";
  }
  /* Lateral-stability: only relevant when this removal SHORTENS the column
     (extends a top-chain downward), which changes the column's height. */
  if (isShortening) {
    const simHoriz = Object.assign({}, state.removedHorizontal);
    simHoriz[`h_${row}_${col}`] = true;
    if (!layoutSatisfiesStability(state.removedTop, simHoriz)) {
      return "A taller column needs an adjacent column within one step in height.";
    }
  }
  return null;
}

function renderLibrary() {
  if (!els.library) return;
  els.library.innerHTML = "";
  moduleDefs.forEach(def => {
    const thumbImg   = def.thumbnail || def.image || "";
    const priceLabel = currency.ready ? money(getDisplayPrice(def.price || 0)) : "…";
    const item = mk("div", null, { className: "mona-item", draggable: true });
    item.dataset.type = def.id;
    item.innerHTML = `
      <div class="mona-item-header" style="display:flex;justify-content:space-between;align-items:baseline;">
        <div class="mona-item-name" style="min-width:0;overflow-wrap:break-word;">${def.name} <span style="font-weight:400;color:#888;font-size:11px;white-space:nowrap;">${def.width}x${def.height}</span></div>
        <div style="font-weight:600;font-size:12px;color:#111;white-space:nowrap;margin-left:8px;">${priceLabel}</div>
      </div>
      <div class="mona-item-preview">
        ${thumbImg ? `<img src="${thumbImg}" alt="${def.name}">` : `<div class="mona-item-fallback">${def.name}</div>`}
      </div>`;
    item.addEventListener("dragstart", e => {
      e.dataTransfer.setData("text/plain", def.id);
      e.dataTransfer.setData("mona-drag-type", "library");
      const ghost = createSquareDragGhost(thumbImg, def.name);
      e.dataTransfer.setDragImage(ghost, 42, 42);
      setTimeout(() => ghost.remove(), 0);
    });
    item.addEventListener("click", () => {
      if (window.innerWidth > 960 && !("ontouchstart" in window)) return;
      let placed = false;
      const isShelf = def.height === 0.5;
      const step = isShelf ? 0.5 : 1;

      if (isShelf) {
        outer: for (let r = state.height - def.height; r >= 0; r -= step) {
          for (let c = 0; c <= state.width - def.width; c++) {
            if (canPlaceAt(r, c, def.width, def.height, -1, def.id)) {
              addModule(def.id, r, c);
              placed = true;
              break outer;
            }
          }
        }
      } else {
        outer: for (let r = 0; r <= state.height - def.height; r += step) {
          for (let c = 0; c <= state.width - def.width; c++) {
            if (canPlaceAt(r, c, def.width, def.height, -1, def.id)) {
              addModule(def.id, r, c);
              placed = true;
              break outer;
            }
          }
        }
      }

      if (!placed) setStatus(isBig2x2ModuleType(def.id) ? T("status_2x2_bottom_only", "The 2x2 box can only sit on the bottom two rows.") : T("status_no_space", "No space available — remove a box first."));
    });
    els.library.appendChild(item);
  });
}

function renderElementsList() {
  if (!els.elementsList) return;
  els.elementsList.innerHTML = "";
  state.modules.forEach((module, index) => {
    const def        = getModuleDef(module.type);
    const finish     = supportsFinish(module.type) ? getFinishDef(module.finish)?.label || module.finish : "";
    const knob       = supportsKnob(module.type)   ? getKnobDef(module.knob)?.label    || module.knob   : "";
    const wtMultiplier = module.type === "wood_top" ? (module.w || 1) : 1;
    const priceLabel = currency.ready ? money(getDisplayPrice((def?.price || 0) * wtMultiplier)) : "…";
    const card = mk("div", null, { className: "mona-element-card" + (module.id === state.selectedModuleId ? " active" : "") });
    card.innerHTML = `
      <div class="mona-element-card-title" style="display:flex;justify-content:space-between;align-items:baseline;">
        <span>${def?.name || module.type} ${index + 1}</span>
        <span style="font-weight:600;font-size:13px;">${priceLabel}</span>
      </div>
      <div class="mona-element-card-meta">${module.w}x${module.h}${finish ? ` · ${finish}` : ""}${knob ? ` · ${knob}` : ""}</div>`;
    card.addEventListener("click", () => selectModule(module.id));
    els.elementsList.appendChild(card);
  });
}

/* ────────────────────────────────────────────────────────────────────────────
   GLOBAL FINISH CONTROL — change every box's finish at once.
   Lives at the top of the customize panel, always visible (when the
   customize panel is the active mode), regardless of selection.
   ──────────────────────────────────────────────────────────────────────────── */
function ensureGlobalFinishControl() {
  const select = document.getElementById("mona-global-finish");
  if (!select) return;

  /* Hide the entire group when there are fewer than 2 finish-supporting boxes —
     no point showing "apply to all" when there's only one (or none). */
  const group = document.getElementById("mona-global-finish-group");
  const finishedCount = state.modules.filter(m => supportsFinish(m.type)).length;
  if (group) group.style.display = finishedCount >= 2 ? "block" : "none";

  /* Populate options once and wire the change handler once */
  if (!select.dataset.monaWired) {
    select.innerHTML = FINISHES.map(f => `<option value="${f.value}">${f.label}</option>`).join("");
    select.addEventListener("change", e => {
      const newFinish = e.target.value;
      if (!FINISHES.some(f => f.value === newFinish)) return;
      state.defaultFinish = newFinish;
      let changed = 0;
      state.modules.forEach(m => {
        if (supportsFinish(m.type) && m.finish !== newFinish) {
          m.finish = newFinish;
          changed++;
        }
      });
      render();
      const label = getFinishDef(newFinish)?.label || newFinish;
      setStatus(changed
        ? `All ${changed} ${changed === 1 ? "box" : "boxes"} set to ${label}.`
        : `Default finish set to ${label}.`);
    });
    select.dataset.monaWired = "1";
  }

  /* Keep the dropdown in sync. If every box that supports a finish shares
     the same finish, show it; otherwise fall back to the default. */
  const finishedModules = state.modules.filter(m => supportsFinish(m.type));
  let displayValue = state.defaultFinish;
  if (finishedModules.length > 0) {
    const first = finishedModules[0].finish;
    const allSame = finishedModules.every(m => m.finish === first);
    if (allSame && FINISHES.some(f => f.value === first)) displayValue = first;
  }
  if (FINISHES.some(f => f.value === displayValue)) {
    select.value = displayValue;
  }
}

function ensureGlobalKnobControl() {
  const select = document.getElementById("mona-global-knob");
  if (!select) return;

  /* Hide when fewer than 2 knob-supporting boxes exist. */
  const group = document.getElementById("mona-global-knob-group");
  const knobbedCount = state.modules.filter(m => supportsKnob(m.type)).length;
  if (group) group.style.display = knobbedCount >= 2 ? "block" : "none";

  /* Populate options once and wire the change handler once */
  if (!select.dataset.monaWired) {
    select.innerHTML = KNOBS
      .filter(k => k.value !== "none")
      .map(k => `<option value="${k.value}">${k.label}</option>`)
      .join("");
    select.addEventListener("change", e => {
      const newKnob = e.target.value;
      if (!KNOBS.some(k => k.value === newKnob)) return;
      let changed = 0;
      state.modules.forEach(m => {
        if (supportsKnob(m.type) && m.knob !== newKnob) {
          m.knob = newKnob;
          changed++;
        }
      });
      render();
      const label = getKnobDef(newKnob)?.label || newKnob;
      setStatus(changed
        ? `All ${changed} ${changed === 1 ? "handle" : "handles"} set to ${label}.`
        : `Handle preference set to ${label}.`);
    });
    select.dataset.monaWired = "1";
  }

  /* Keep the dropdown in sync with the modules' actual knob state. */
  const knobbedModules = state.modules.filter(m => supportsKnob(m.type));
  if (knobbedModules.length > 0) {
    const first = knobbedModules[0].knob;
    const allSame = knobbedModules.every(m => m.knob === first);
    if (allSame && KNOBS.some(k => k.value === first && k.value !== "none")) {
      select.value = first;
    }
  }
}

function renderInspector() {
  if (!els.inspectorEmpty || !els.inspectorFields) return;
  const module = getSelectedModule();
  if (!module) {
    els.inspectorEmpty.style.display  = "block";
    els.inspectorFields.style.display = "none";
    return;
  }
  els.inspectorEmpty.style.display  = "none";
  els.inspectorFields.style.display = "block";
  if (els.boxFinish) {
    els.boxFinish.innerHTML = FINISHES.map(f => `<option value="${f.value}">${f.label}</option>`).join("");
    els.boxFinish.value     = supportsFinish(module.type) ? module.finish : state.defaultFinish;
    els.boxFinish.disabled  = !supportsFinish(module.type);
  }
  if (els.knobGroup) els.knobGroup.style.display = supportsKnob(module.type) ? "block" : "none";
  if (els.boxKnob && supportsKnob(module.type)) {
    els.boxKnob.innerHTML = KNOBS.map(k => `<option value="${k.value}">${k.label}</option>`).join("");
    els.boxKnob.value     = module.knob || "none";
  }
}

function renderPriceBreakdown() {
  if (!els.priceBreakdown) return;
  const w = state.width, h = state.height;
  const q = computeStructuralQuantities();
  const T = window.MONA_T || {};
  const fmt = price => currency.ready ? money(toDisplay(price)) : "…";
  const structuralRow = (label, qty, unitPrice) => qty > 0
    ? `<div class="mona-breakdown-row"><span>${label} × ${qty}</span><strong>${fmt(qty * unitPrice)}</strong></div>`
    : "";
  const structuralSection = `
    <div style="font-size:11px;font-weight:700;color:#888;padding:8px 0 4px;letter-spacing:.04em;text-transform:uppercase;">${T.structure_section_title || "Structure"} (${w}×${h})</div>
    ${structuralRow(T.uframe_label || "U-Frame",                q.uFrames,     STRUCT.uFrame?.price || 0)}
    ${structuralRow(T.connector_label || "Connector",           q.connectors,  STRUCT.connector?.price || 0)}
    ${structuralRow(T.base_rectangle_label || "Base Rectangle", q.baseRects,   STRUCT.baseRectangle?.price || 0)}
    ${structuralRow(T.shelf_panel_label || "Shelf Panel",       q.shelfPanels, STRUCT.shelfPanel?.price || 0)}
    ${structuralRow(T.foot_label || "Foot",                     q.feet,        STRUCT.foot?.price || 0)}
  `;
  const boxSection = state.modules.length > 0
    ? `<div style="font-size:11px;font-weight:700;color:#888;padding:8px 0 4px;letter-spacing:.04em;text-transform:uppercase;">${T.boxes_section_title || "Boxes"}</div>` +
      state.modules.map((m, i) => {
        const def    = getModuleDef(m.type);
        const finish = supportsFinish(m.type) ? ` · ${getFinishDef(m.finish)?.label || m.finish}` : "";
        const wtMultiplier = m.type === "wood_top" ? (m.w || 1) : 1;
        const widthLabel = m.type === "wood_top" && m.w > 1 ? ` (${m.w} ${T.wood_top_wide_suffix || "wide"})` : "";
        return `<div class="mona-breakdown-row"><span>${def?.name || m.type} ${i + 1}${widthLabel}${finish}</span><strong>${fmt((def?.price || 0) * wtMultiplier)}</strong></div>`;
      }).join("")
    : "";
  const configRow = getConfigFeeTRY() > 0
    ? `<div class="mona-breakdown-row"><span>${T.config_fee_label || "Configuration"}</span><strong>${fmt(getConfigFeeTRY())}</strong></div>`
    : "";
  const totalRow = `
    <div class="mona-breakdown-row mona-breakdown-total" style="margin-top:6px;">
      <span>${T.total_row_label || "Total"}</span><strong>${currency.ready ? money(getTotalPrice()) : "…"}</strong>
    </div>`;
  els.priceBreakdown.innerHTML = structuralSection + boxSection + configRow + totalRow;
}

function setRightPanelMode(mode) {
  state.rightPanelMode = mode;
  const isC = mode === "customize";
  if (els.rightPanelTitle) els.rightPanelTitle.textContent = isC ? ((window.MONA_T && window.MONA_T.panel_customize) || "Customize") : ((window.MONA_T && window.MONA_T.panel_price_summary) || "Price Summary");
  if (els.rightPanelCustomize) els.rightPanelCustomize.style.display = isC ? "block" : "none";
  if (els.rightPanelPrice)     els.rightPanelPrice.style.display     = isC ? "none"  : "block";
  els.openCustomize?.classList.toggle("is-active",  isC);
  els.openPrice?.classList.toggle("is-active",     !isC);
  if (!isC) renderPriceBreakdown();
}
function makeBar(left, top, width, height, color, extra = {}) {
  /* Renders a square steel tube (1.5cm x 1.5cm cross-section = LINE x LINE)
     extruded into -Z direction. The wrapper sits at the same screen rect
     as a flat plane would — callers don't need to change anything.

     Horizontal bars (rails) get: front, back, top, bottom faces.
     Vertical bars (posts)  get: front, back, left,  right faces.
     End caps are intentionally omitted at every "open mouth" — adjacent
     perpendicular profiles cover those, mirroring the real product where
     tubes butt cleanly at internal joints.

     Decorative pieces (base feet caps, etc.) that pass `borderRadius` or
     an explicit `background` opt out and render as flat colored divs. */
  const wrap = mk("div", null);
  Object.assign(wrap.style, {
    position: "absolute",
    left: `${left}px`, top: `${top}px`,
    width: `${width}px`, height: `${height}px`,
    transformStyle: "preserve-3d",
    backfaceVisibility: "visible",
    webkitBackfaceVisibility: "visible",
    willChange: "transform",
    pointerEvents: "none",
    ...extra
  });

  if (extra.borderRadius || extra.background) {
    wrap.style.background = extra.background || color;
    return wrap;
  }

  const thickness = Math.min(width, height);

  const addFace = (cssText) => {
    const f = document.createElement("div");
    f.style.cssText = `position:absolute;backface-visibility:visible;` +
                      `-webkit-backface-visibility:visible;pointer-events:none;` +
                      `background:${color};${cssText}`;
    wrap.appendChild(f);
  };

  /* Front face at z = 0 */
  addFace(`left:0;top:0;width:${width}px;height:${height}px;`);
  /* Back face at z = -thickness */
  addFace(`left:0;top:0;width:${width}px;height:${height}px;` +
          `transform:translateZ(-${thickness}px);`);

  if (width >= height) {
    /* Horizontal bar — top face (at y=0) and bottom face (at y=height),
       each extending into -Z by `thickness`. */
    addFace(`left:0;top:0;width:${width}px;height:${thickness}px;` +
            `transform-origin:top center;transform:rotateX(-90deg);`);
    addFace(`left:0;top:${height}px;width:${width}px;height:${thickness}px;` +
            `transform-origin:top center;transform:rotateX(-90deg);`);
  } else {
    /* Vertical bar — left face (at x=0) and right face (at x=width),
       each extending into -Z by `thickness`. */
    addFace(`left:0;top:0;width:${thickness}px;height:${height}px;` +
            `transform-origin:left center;transform:rotateY(90deg);`);
    addFace(`left:${width}px;top:0;width:${thickness}px;height:${height}px;` +
            `transform-origin:left center;transform:rotateY(90deg);`);
  }

  return wrap;
}

const depthTube = (x, y, color) => {
  /* Front-to-back connector tube: LINE × LINE cross-section extending from
     z=0 (front of the unit) to z=-DEPTH (back). Built explicitly with 4 side
     faces in proper 3D positions — no wrapper-rotation trick — so the back
     end stays perfectly aligned with the front X coordinate. The front and
     back are intentionally open (no caps) because the rails butting against
     them cover those mouths. */
  const wrap = mk("div", null);
  Object.assign(wrap.style, {
    position: "absolute",
    left: `${x}px`, top: `${y}px`,
    width: `${LINE}px`, height: `${LINE}px`,
    transformStyle: "preserve-3d",
    backfaceVisibility: "visible",
    webkitBackfaceVisibility: "visible",
    pointerEvents: "none",
    zIndex: "3"
  });

  const addFace = (cssText) => {
    const f = document.createElement("div");
    f.style.cssText = `position:absolute;backface-visibility:visible;` +
                      `-webkit-backface-visibility:visible;pointer-events:none;` +
                      `background:${color};${cssText}`;
    wrap.appendChild(f);
  };

  /* Top face: lies flat on top, extending backward into -Z */
  addFace(`left:0;top:0;width:${LINE}px;height:${DEPTH}px;` +
          `transform-origin:top center;transform:rotateX(-90deg);`);
  /* Bottom face: lies flat on bottom, extending backward */
  addFace(`left:0;top:${LINE}px;width:${LINE}px;height:${DEPTH}px;` +
          `transform-origin:top center;transform:rotateX(-90deg);`);
  /* Left face: vertical plane at x=0, extending backward */
  addFace(`left:0;top:0;width:${DEPTH}px;height:${LINE}px;` +
          `transform-origin:left center;transform:rotateY(90deg);`);
  /* Right face: vertical plane at x=LINE, extending backward */
  addFace(`left:${LINE}px;top:0;width:${DEPTH}px;height:${LINE}px;` +
          `transform-origin:left center;transform:rotateY(90deg);`);

  return wrap;
};

function buildGrid(targetEl, frameColor, showMeasurements) {
  const W = state.width * CELL, H = state.height * CELL, baseY = H + LINE / 2 + 12;
  targetEl.style.width  = `${W}px`;
  targetEl.style.height = `${H + 60}px`;
  targetEl.style.transformStyle = "preserve-3d";

  /* Rails between stacked boxes are no longer hidden — boxes are always
     fully surrounded by their bounding rails. Kept as a no-op for callers. */
  const railBetweenStackedBoxes = () => false;

  /* Front-face horizontal rails */
  for (let row = 0; row <= state.height; row++)
    for (let col = 0; col < state.width; col++) {
      if (row === 0 && state.removedTop[`top_${col}`]) continue;
      if (row > 0 && row < state.height && horizontalRailRemoved(row, col)) continue;
      if (state.modules.some(m => moduleSpansHorizontalRail(m, row, col))) continue;
      if (railBetweenStackedBoxes(row, col)) continue;
      /* Extend the rail slightly past its column edges so it overlaps the
         posts on either side, hiding the tiny seam between rail and post. */
      targetEl.appendChild(makeBar(col * CELL - LINE / 2, row * CELL - LINE / 2, CELL + LINE, LINE, frameColor, { zIndex: "4" }));
      if (row === 0) {
        const backBar = makeBar(col * CELL, row * CELL - LINE / 2, CELL, LINE, frameColor, { zIndex: "4" });
        backBar.style.transform = `translateZ(-${DEPTH}px)`;
        targetEl.appendChild(backBar);
      }
    }

  /* Front-face vertical posts and edge trims.
     Posts and trims follow column height: only draw at rows where the
     adjacent column actually has a cell present. */
  for (let row = 0; row < state.height; row++) {
    const y = row * CELL;
    /* Left edge trim */
    const leftHasCellEdge = columnHasCellAtRow(0, row);
    if (!state.leftTrim[row] && leftHasCellEdge) {
      targetEl.appendChild(makeBar(-LINE / 2, y, LINE, CELL, frameColor, { zIndex: "4" }));
    }
    /* Inner posts at col boundary — draw if at least one adjacent col has a cell */
    for (let col = 0; col < state.width - 1; col++) {
      if (isVerticalDividerRemoved(row, col)) continue;
      if (!columnHasCellAtRow(col, row) && !columnHasCellAtRow(col + 1, row)) continue;
      targetEl.appendChild(makeBar((col + 1) * CELL - LINE / 2, y, LINE, CELL, frameColor, { zIndex: "4" }));
    }
    /* Right edge trim */
    const lastCol = state.width - 1;
    const rightHasCellEdge = columnHasCellAtRow(lastCol, row);
    if (!state.rightTrim[row] && rightHasCellEdge) {
      targetEl.appendChild(makeBar(W - LINE / 2, y, LINE, CELL, frameColor, { zIndex: "4" }));
    }
  }

  /* Shelf panels (the depth-z surfaces on top of each shelf).
     A shelf panel is hidden ONLY when:
     1. It sits inside a box's body (between m.row and m.row + m.h, exclusive).
     2. It sits directly above a shelf module (h=0.5) whose user has opted to
        remove the top shelf — and no other box is stacked on top of it.
     Top and bottom edges of regular boxes still get their shelves rendered:
     every box must be flanked by shelves above and below. */
  const shelfStart = state.height <= 3 ? 0 : 1;
  for (let row = shelfStart; row <= state.height; row++) {
    for (let col = 0; col < state.width; col++) {
      if (row === 0 && state.removedTop[`top_${col}`]) continue;
      if (row > 0 && row < state.height && horizontalRailRemoved(row, col)) continue;
      if (state.modules.some(m => {
        if (m.type === "wood_top") return false;
        if (col < m.col || col >= m.col + m.w) return false;
        /* Inside the box body — the box itself encloses this surface */
        if (row > m.row && row < m.row + m.h) return true;
        /* Shelf module: hide the shelf directly above it ONLY when the user
           opted to remove it AND no other box is stacked on top. A box above
           always restores the shelf so it has a proper floor under it. */
        if (m.h === 0.5 && row === Math.floor(m.row) && m.removeTopShelf) {
          const hasBoxAbove = state.modules.some(other =>
            other.id !== m.id &&
            other.type !== "wood_top" &&
            other.col <= col && col < other.col + other.w &&
            Math.ceil(other.row + other.h) === Math.floor(m.row)
          );
          if (!hasBoxAbove) return true;
        }
        return false;
      })) continue;
      /* Shelf panels between stacked boxes are no longer hidden — boxes are
         always fully surrounded by their bounding rails and shelves. */
      targetEl.appendChild(mk("div", `position:absolute;left:${col * CELL}px;top:${row * CELL - LINE / 2}px;
        width:${CELL}px;height:${DEPTH}px;background:${frameColor};transform-origin:left top;
        transform:rotateX(-90deg);z-index:7;backface-visibility:visible;-webkit-backface-visibility:visible;
        transform-style:preserve-3d;pointer-events:none;`));
    }
  }

  /* Depth tubes at each column boundary, at every row level */
  for (let col = 1; col < state.width; col++) {
    for (let row = 0; row <= state.height; row++) {
      const leftRailGone = row === 0
        ? state.removedTop[`top_${col - 1}`]
        : (row < state.height ? (horizontalRailRemoved(row, col - 1) || railBetweenStackedBoxes(row, col - 1)) : false);
      const rightRailGone = row === 0
        ? state.removedTop[`top_${col}`]
        : (row < state.height ? (horizontalRailRemoved(row, col) || railBetweenStackedBoxes(row, col)) : false);
      if (leftRailGone && rightRailGone) continue;
      /* At row 0: skip the depth tube + top plate if the vertical divider
         directly below them (row 0, between col-1 and col) is removed —
         the connector sits on top of that divider, so it has nothing to
         attach to. */
      if (row === 0 && isVerticalDividerRemoved(0, col - 1)) continue;
      targetEl.appendChild(depthTube(col * CELL - LINE / 2, row * CELL - LINE / 2, frameColor));
    }
    targetEl.appendChild(depthTube(col * CELL - LINE / 2, baseY, frameColor));
    targetEl.appendChild(depthTube(col * CELL - LINE / 2, H + LINE / 2, frameColor));
  }

  /* Back panel */
  const back = mk("div", `position:absolute;left:0;top:0;width:${W}px;height:${H + 30}px;
    transform-origin:center center;transform:translateZ(-${DEPTH}px);z-index:1;overflow:visible;
    backface-visibility:visible;-webkit-backface-visibility:visible;transform-style:preserve-3d;
    pointer-events:none;`);
  for (let row = 0; row <= state.height; row++)
    for (let col = 0; col < state.width; col++) {
      if (row === 0 && state.removedTop[`top_${col}`]) continue;
      if (row > 0 && row < state.height && horizontalRailRemoved(row, col)) continue;
      if (railBetweenStackedBoxes(row, col)) continue;
      back.appendChild(makeBar(col * CELL - LINE / 2, row * CELL - LINE / 2, CELL + LINE, LINE, frameColor));
    }
  for (let row = 0; row < state.height; row++) {
    const y = row * CELL;
    const leftHasCellEdge = columnHasCellAtRow(0, row);
    if (!state.leftTrim[row] && leftHasCellEdge) {
      back.appendChild(makeBar(-LINE / 2, y, LINE, CELL, frameColor));
    }
    for (let col = 0; col < state.width - 1; col++) {
      if (isVerticalDividerRemoved(row, col)) continue;
      if (!columnHasCellAtRow(col, row) && !columnHasCellAtRow(col + 1, row)) continue;
      back.appendChild(makeBar((col + 1) * CELL - LINE / 2, y, LINE, CELL, frameColor));
    }
    const lastCol = state.width - 1;
    const rightHasCellEdge = columnHasCellAtRow(lastCol, row);
    if (!state.rightTrim[row] && rightHasCellEdge) {
      back.appendChild(makeBar(W - LINE / 2, y, LINE, CELL, frameColor));
    }
  }
  back.appendChild(makeBar(0, baseY, W, LINE, frameColor));
  for (let i = 0; i <= state.width; i++) {
    back.appendChild(makeBar(i * CELL - LINE / 2, H + LINE / 2, LINE, 12, frameColor));
    back.appendChild(makeBar(i * CELL - 4, baseY + LINE, 8, 5, frameColor, { borderRadius: "4px 4px 0 0" }));
  }
  targetEl.appendChild(back);

  function sidePanel(leftPx, topKey, sideCol) {
    const panel = mk("div", `position:absolute;left:${leftPx}px;top:0;width:${DEPTH}px;height:${H}px;
      transform-origin:left center;transform:rotateY(90deg);z-index:2;overflow:visible;
      backface-visibility:visible;-webkit-backface-visibility:visible;transform-style:preserve-3d;
      pointer-events:none;`);
    for (let row = 0; row <= state.height; row++) {
      if (row === 0 && state.removedTop[topKey]) continue;
      if (row > 0 && row < state.height && horizontalRailRemoved(row, sideCol)) continue;
      /* Hide the inner-row rail on a side panel when a wide box (w>=2)        spans that row in the adjacent edge column. The box's own surface        already covers the rail visually, and the rail looks like a stray        line cutting through the box. */
      if (row > 0 && row < state.height && state.modules.some(m =>
        m.type !== "wood_top" &&
        m.w >= 2 &&
        m.col <= sideCol && sideCol < m.col + m.w &&
        m.row < row && row < m.row + m.h
      )) continue;
      panel.appendChild(makeBar(0, row * CELL - LINE / 2, DEPTH, LINE, frameColor));
    }
    panel.appendChild(makeBar(0, baseY, DEPTH, LINE, frameColor));
    panel.appendChild(makeBar(0, baseY + LINE, 8, 5, frameColor, { borderRadius: "4px 4px 0 0" }));
    panel.appendChild(makeBar(DEPTH - 8, baseY + LINE, 8, 5, frameColor, { borderRadius: "4px 4px 0 0" }));
    return panel;
  }
  targetEl.appendChild(sidePanel(LINE / 2, "top_0", 0));
  /* The right panel uses opposite rotation so its inner tube faces extrude
     INTO the unit (hidden) instead of out to the right (visible as a ghost). */
  const rightPanel = sidePanel(W - LINE / 2 - DEPTH, `top_${state.width - 1}`, state.width - 1);
  rightPanel.style.transformOrigin = "right center";
  rightPanel.style.transform = "rotateY(-90deg)";
  targetEl.appendChild(rightPanel);

  targetEl.appendChild(makeBar(0, baseY, W, LINE, frameColor, { zIndex: "8" }));
  for (let i = 0; i <= state.width; i++) {
    targetEl.appendChild(makeBar(i * CELL - LINE / 2, H + LINE / 2, LINE, 12, frameColor, { zIndex: "8" }));
    targetEl.appendChild(makeBar(i * CELL - 4, baseY + LINE, 8, 5, frameColor, { borderRadius: "4px 4px 0 0", zIndex: "8" }));
  }

  if (showMeasurements) {
    const totalW = state.width * 40;
    const totalH = state.height * 40 + 10;
    const totalD = 40;
    const labelStyle = "position:absolute;font-size:11px;font-weight:700;color:#111;white-space:nowrap;background:rgba(255,255,255,0.92);padding:2px 6px;border-radius:3px;pointer-events:none;box-shadow:0 1px 3px rgba(0,0,0,0.15);";
    const lineStyle  = "position:absolute;background:#111;pointer-events:none;";

    /* WIDTH — bottom front edge, runs left→right along the bottom of the front face.
       Sits in the z=0 plane (front), just below the unit. */
    const wLine = mk("div", `${lineStyle}left:0;top:${H + 20}px;width:${W}px;height:2px;transform-style:preserve-3d;`);
    targetEl.appendChild(wLine);
    /* End caps */
    targetEl.appendChild(mk("div", `${lineStyle}left:-1px;top:${H + 14}px;width:2px;height:14px;`));
    targetEl.appendChild(mk("div", `${lineStyle}left:${W - 1}px;top:${H + 14}px;width:2px;height:14px;`));
    const wLabel = mk("div", `${labelStyle}left:${W / 2}px;top:${H + 28}px;transform:translateX(-50%);`);
    wLabel.textContent = `${totalW} cm`;
    targetEl.appendChild(wLabel);

    /* HEIGHT — back-left vertical edge, runs from floor to top at the back of the unit.
       Built as a wrapper that sits at the left edge of the unit but is pushed back
       into the z plane (translateZ(-DEPTH)) so it sits along the back-left corner. */
    const hWrap = mk("div", `position:absolute;left:-20px;top:0;width:2px;height:${H}px;transform:translateZ(-${DEPTH}px);transform-style:preserve-3d;pointer-events:none;`);
    hWrap.appendChild(mk("div", `${lineStyle}left:0;top:0;width:2px;height:${H}px;`));
    /* End caps */
    hWrap.appendChild(mk("div", `${lineStyle}left:-6px;top:-1px;width:14px;height:2px;`));
    hWrap.appendChild(mk("div", `${lineStyle}left:-6px;top:${H - 1}px;width:14px;height:2px;`));
    const hLabel = mk("div", `${labelStyle}left:-8px;top:${H / 2}px;transform:translate(-100%,-50%);`);
    hLabel.textContent = `${totalH} cm`;
    hWrap.appendChild(hLabel);
    targetEl.appendChild(hWrap);

    /* DEPTH — floor, left edge, runs front-to-back along the bottom-left edge.
       Built as a wrapper rotated to lie flat on the floor, extending 
       front (z=0) to back (z=-DEPTH). */
    const dWrap = mk("div", `position:absolute;left:-2px;top:${H + LINE / 2}px;width:2px;height:${DEPTH}px;transform-origin:left top;transform:rotateX(-90deg);transform-style:preserve-3d;pointer-events:none;`);
    dWrap.appendChild(mk("div", `${lineStyle}left:0;top:0;width:2px;height:${DEPTH}px;`));
    /* End caps */
    dWrap.appendChild(mk("div", `${lineStyle}left:-6px;top:-1px;width:14px;height:2px;`));
    dWrap.appendChild(mk("div", `${lineStyle}left:-6px;top:${DEPTH - 1}px;width:14px;height:2px;`));
    /* Counter-rotate label so it reads correctly when viewed from above.
       The parent rotateX(-90deg) flips us face-down; rotateY(180deg) on the label
       spins it back to face-up so the text is readable. */
    const dLabel = mk("div", `${labelStyle}left:-8px;top:${DEPTH / 2}px;transform:translate(-100%,-50%) rotateY(180deg);`);
    dLabel.textContent = `${totalD} cm`;
    dWrap.appendChild(dLabel);
    targetEl.appendChild(dWrap);
  }

  state.modules.forEach((module, index) => {
    const def         = getModuleDef(module.type);
    normalizeModuleOptions(module);
    const finishColor = fallbackFinishColor(module.finish || state.defaultFinish);
    const frontImage  = resolveModuleAsset(def, "front", module.finish, module.knob);
    const sideImage   = resolveModuleAsset(def, "side",  module.finish);
    const topImage    = resolveModuleAsset(def, "top",   module.finish);
    const backImage   = resolveModuleAsset(def, "back",  module.finish);
    const backRepeat  = def?.assets?.backRepeat || 1;
    const wPx = module.w * CELL - 4, hPx = module.h * CELL - 4, topPx = module.row * CELL + 2;
    const modFace = css => mk("div", css);

    if (module.type === "wood_top") {
      const PANEL_H = 6;
      const woodImg = topImage || frontImage || sideImage;
      const bgCss   = woodImg ? `url('${woodImg}')` : "none";
      const panel   = mk("div", `position:absolute;left:${module.col * CELL}px;top:${module.row * CELL - PANEL_H + LINE / 2}px;
        width:${module.w * CELL}px;height:${PANEL_H}px;overflow:visible;
        background-image:${bgCss};background-color:${woodImg ? "transparent" : finishColor};
        background-size:100% 100%;background-position:center;background-repeat:no-repeat;
        transform-style:preserve-3d;z-index:9;cursor:grab;`,
        { className: "mona-module" + (module.id === state.selectedModuleId ? " is-selected" : ""), draggable: true });
      panel.dataset.moduleId = module.id;
      const topFace = mk("div", `position:absolute;left:0;top:${-DEPTH}px;width:${module.w * CELL}px;height:${DEPTH}px;transform-origin:center bottom;transform:rotateX(90deg);z-index:9;overflow:hidden;background:${finishColor};`);
      if (woodImg) {
        const innerImg = mk("img", `position:absolute;top:50%;left:50%;height:${module.w * CELL}px;width:${DEPTH}px;transform:translate(-50%,-50%) rotate(90deg);object-fit:cover;pointer-events:none;`, { src: woodImg });
        topFace.appendChild(innerImg);
      }
      panel.appendChild(topFace);
      const sideEdgeBg = woodImg
        ? `background-image:url('${woodImg}');background-color:transparent;background-size:cover;background-repeat:no-repeat;background-position:center;`
        : `background:${finishColor};filter:brightness(0.7);`;
      panel.appendChild(modFace(`position:absolute;left:${module.w * CELL}px;top:0;width:${DEPTH}px;height:${PANEL_H}px;transform-origin:left center;transform:rotateY(90deg);z-index:8;${sideEdgeBg}`));
      panel.appendChild(modFace(`position:absolute;left:${-DEPTH}px;top:0;width:${DEPTH}px;height:${PANEL_H}px;transform-origin:right center;transform:rotateY(-90deg);z-index:8;${sideEdgeBg}`));
      const removeBtn = mk("button", `position:absolute;top:-10px;right:-10px;width:18px;height:18px;border-radius:50%;
        border:1px solid #ccc;background:#fff;color:#999;font-size:12px;cursor:pointer;
        display:flex;align-items:center;justify-content:center;z-index:20;padding:0;`,
        { type: "button", className: "mona-module-remove", innerHTML: "×" });
      removeBtn.addEventListener("click", e => {
        e.stopPropagation();
        state.modules.splice(index, 1);
        if (state.selectedModuleId === module.id) state.selectedModuleId = state.modules[0]?.id || null;
        normalizeManualDividerState(); render(); setStatus(T("status_wood_top_removed", "Wood Top removed."));
      });
      panel.appendChild(removeBtn);
      panel.addEventListener("click", e => { e.stopPropagation(); selectModule(module.id, true); });
      panel.addEventListener("dragstart", e => { e.dataTransfer.setData("mona-drag-type", "move"); e.dataTransfer.setData("mona-module-index", String(index)); });
      if (module.id === state.selectedModuleId) {
        const btnBase  = `position:absolute;top:-22px;width:18px;height:18px;border-radius:50%;
          border:1px solid rgba(0,0,0,0.3);background:rgba(255,255,255,0.9);color:#111;font-size:14px;
          line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:20;padding:0;`;
        const minusBtn = mk("button", btnBase + "left:4px;", { type: "button", innerHTML: "−" });
        minusBtn.addEventListener("click", e => {
          e.stopPropagation();
          if (canShrinkWoodTop(index)) { module.w--; normalizeManualDividerState(); render(); setStatus(T("status_wood_top_narrowed", "Wood Top narrowed.")); }
          else setStatus(T("status_wood_top_min_width", "Already at minimum width."));
        });
        panel.appendChild(minusBtn);
        const plusBtn = mk("button", btnBase + "right:4px;", { type: "button", innerHTML: "+" });
        plusBtn.addEventListener("click", e => {
          e.stopPropagation();
          if (canExpandWoodTop(index)) { module.w++; normalizeManualDividerState(); render(); setStatus(T("status_wood_top_widened", "Wood Top widened.")); }
          else {
            const pc = module.col - 1;
            const leftSurface = pc >= 0 ? getColumnTopSurfaceRow(pc) : null;
            const leftEligible = leftSurface === module.row &&
              !state.modules.some((o, i) => i !== index && o.type === "wood_top" && pc >= o.col && pc < o.col + o.w);
            if (leftEligible) {
              module.col--; module.w++; normalizeManualDividerState(); render(); setStatus(T("status_wood_top_widened", "Wood Top widened."));
            } else setStatus(T("status_wood_top_no_expand", "Cannot expand further."));
          }
        });
        panel.appendChild(plusBtn);

        const moveBtnBase = `position:absolute;top:-44px;width:18px;height:18px;border-radius:50%;
          border:1px solid rgba(0,0,0,0.3);background:rgba(255,255,255,0.9);color:#111;font-size:14px;
          line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:20;padding:0;`;
        const moveLeftBtn = mk("button", moveBtnBase + "left:4px;", { type: "button", innerHTML: "‹" });
        moveLeftBtn.addEventListener("click", e => {
          e.stopPropagation();
          const nc = module.col - 1;
          if (nc < 0) { setStatus(T("status_wood_top_leftmost", "Already at leftmost position.")); return; }
          let canMove = true;
          for (let c = nc; c < nc + module.w; c++) {
            if (getColumnTopSurfaceRow(c) !== module.row) { canMove = false; break; }
            if (state.modules.some((o, i) => i !== index && o.type === "wood_top" && c >= o.col && c < o.col + o.w)) { canMove = false; break; }
          }
          if (!canMove) { setStatus(T("status_cannot_move", "Cannot move there.")); return; }
          module.col = nc; normalizeManualDividerState(); render(); setStatus(T("status_wood_top_moved_left", "Wood Top moved left."));
        });
        panel.appendChild(moveLeftBtn);

        const moveRightBtn = mk("button", moveBtnBase + "right:4px;", { type: "button", innerHTML: "›" });
        moveRightBtn.addEventListener("click", e => {
          e.stopPropagation();
          const nc = module.col + 1;
          if (nc + module.w > state.width) { setStatus(T("status_wood_top_rightmost", "Already at rightmost position.")); return; }
          let canMove = true;
          for (let c = nc; c < nc + module.w; c++) {
            if (getColumnTopSurfaceRow(c) !== module.row) { canMove = false; break; }
            if (state.modules.some((o, i) => i !== index && o.type === "wood_top" && c >= o.col && c < o.col + o.w)) { canMove = false; break; }
          }
          if (!canMove) { setStatus(T("status_cannot_move", "Cannot move there.")); return; }
          module.col = nc; normalizeManualDividerState(); render(); setStatus(T("status_wood_top_moved_right", "Wood Top moved right."));
        });
        panel.appendChild(moveRightBtn);
      }

      targetEl.appendChild(panel);
      return;
    }

    const isOpenBoxType = module.type === "open_1x1" || module.type === "open_2x1";
    const bgCss = (frontImage && !isOpenBoxType) ? `url('${frontImage}')` : "none";
    const mod   = mk("div", `position:absolute;left:${module.col * CELL + 2}px;top:${topPx}px;
      width:${wPx}px;height:${hPx}px;overflow:visible;background-image:${bgCss};
      background-color:transparent;background-size:100% 100%;
      background-position:center;background-repeat:no-repeat;transform-style:preserve-3d;cursor:grab;z-index:6;`,
      { className: "mona-module" + (module.id === state.selectedModuleId ? " is-selected" : ""), draggable: true });
    mod.dataset.moduleId = module.id;

    const sideBg = sideImage
      ? `background-image:url('${sideImage}');background-color:transparent;background-size:100% 100%;background-repeat:no-repeat;`
      : `background:${finishColor};filter:brightness(0.7);`;
    const topBg  = topImage
      ? `background-image:url('${topImage}');background-color:transparent;background-size:100% 100%;background-repeat:no-repeat;`
      : `background:${finishColor};filter:brightness(0.85);`;

    if (isOpenBoxType && frontImage) {
      const useTiledSideForBack = module.type === 'open_2x1' && module.finish === 'oak';
      const backBgImage  = useTiledSideForBack ? (sideImage || frontImage) : frontImage;
      const backBgSize   = useTiledSideForBack ? '50% 100%' : '100% 100%';
      const backBgRepeat = useTiledSideForBack ? 'repeat-x' : 'no-repeat';
      mod.appendChild(modFace(`position:absolute;left:0;top:0;width:${wPx}px;height:${hPx}px;
        transform-origin:center center;transform:translateZ(-${DEPTH}px);z-index:4;
        background-image:url('${backBgImage}');background-color:transparent;
        background-size:${backBgSize};background-repeat:${backBgRepeat};background-position:center;
        box-shadow:inset 0 0 0 2px rgba(0,0,0,0.55), inset 0 15px 40px rgba(0,0,0,0.35), inset 0 -10px 30px rgba(0,0,0,0.25);`));

      const floorImage = frontImage || topImage || sideImage;
      mod.appendChild(modFace(`position:absolute;left:0;top:${hPx - 4}px;width:${wPx}px;height:${DEPTH}px;
        transform-origin:center top;transform:rotateX(-90deg) translateZ(2px);z-index:10;
        background-image:url('${floorImage}');background-color:transparent;background-size:100% 100%;
        background-repeat:no-repeat;background-position:center;
        box-shadow:inset 0 0 0 2px rgba(0,0,0,0.55);`));

      const WALL_THICKNESS = 6;
      const closed2x2Def   = moduleDefs.find(m => m.id === 'closed_2x2');
      const edgeImage      = resolveModuleAsset(closed2x2Def, 'side', module.finish) || frontImage;
      const edgeBg = `background-image:url('${edgeImage}');background-color:transparent;background-size:cover;background-repeat:no-repeat;background-position:center;`;

      mod.appendChild(modFace(`position:absolute;left:${wPx - WALL_THICKNESS}px;top:0;width:${DEPTH}px;height:${hPx}px;
        transform-origin:left center;transform:rotateY(90deg);z-index:6;
        background-image:url('${sideImage || frontImage}');background-color:transparent;background-size:100% 100%;
        background-repeat:no-repeat;background-position:center;`));
      mod.appendChild(modFace(`position:absolute;left:${-DEPTH + WALL_THICKNESS}px;top:0;width:${DEPTH}px;height:${hPx}px;
        transform-origin:right center;transform:rotateY(-90deg);z-index:6;
        background-image:url('${sideImage || frontImage}');background-color:transparent;background-size:100% 100%;
        background-repeat:no-repeat;background-position:center;`));
      mod.appendChild(modFace(`position:absolute;left:0;top:${-DEPTH + WALL_THICKNESS}px;width:${wPx}px;height:${DEPTH}px;
        transform-origin:center bottom;transform:rotateX(90deg);z-index:6;
        background-image:url('${topImage || sideImage || frontImage}');background-color:transparent;background-size:100% 100%;
        background-repeat:no-repeat;background-position:center;`));
      mod.appendChild(modFace(`position:absolute;left:0;top:${hPx - WALL_THICKNESS}px;width:${wPx}px;height:${DEPTH}px;
        transform-origin:center top;transform:rotateX(-90deg);z-index:6;
        background-image:url('${topImage || sideImage || frontImage}');background-color:transparent;background-size:100% 100%;
        background-repeat:no-repeat;background-position:center;`));

      mod.appendChild(modFace(`position:absolute;left:${wPx - WALL_THICKNESS}px;top:0;width:${WALL_THICKNESS}px;height:${hPx}px;z-index:11;${edgeBg}`));
      mod.appendChild(modFace(`position:absolute;left:0;top:0;width:${WALL_THICKNESS}px;height:${hPx}px;z-index:11;${edgeBg}`));
      mod.appendChild(modFace(`position:absolute;left:0;top:0;width:${wPx}px;height:${WALL_THICKNESS}px;z-index:11;${edgeBg}`));
      mod.appendChild(modFace(`position:absolute;left:0;top:${hPx - WALL_THICKNESS}px;width:${wPx}px;height:${WALL_THICKNESS}px;z-index:11;${edgeBg}`));

      mod.appendChild(modFace(`position:absolute;left:${WALL_THICKNESS}px;top:${WALL_THICKNESS}px;
        width:${wPx - WALL_THICKNESS * 2}px;height:${hPx - WALL_THICKNESS * 2}px;
        z-index:12;pointer-events:none;border:1px solid rgba(0,0,0,0.8);background:transparent;`));
    }

    mod.appendChild(modFace(`position:absolute;left:${wPx}px;top:0;width:${DEPTH}px;height:${hPx}px;transform-origin:left center;transform:rotateY(90deg);z-index:5;${sideBg}`));
    mod.appendChild(modFace(`position:absolute;left:${-DEPTH}px;top:0;width:${DEPTH}px;height:${hPx}px;transform-origin:right center;transform:rotateY(-90deg);z-index:5;${sideBg}`));

    /* Back face for closed boxes (open boxes & shelves render their own back face below) */
    if (!isOpenBoxType && module.h !== 0.5 && backImage) {
      const backBgSize   = backRepeat > 1 ? `${100 / backRepeat}% 100%` : '100% 100%';
      const backBgRepeat = backRepeat > 1 ? 'repeat-x' : 'no-repeat';
      mod.appendChild(modFace(`position:absolute;left:0;top:0;width:${wPx}px;height:${hPx}px;
        transform-origin:center center;transform:translateZ(-${DEPTH}px);z-index:4;
        background-image:url('${backImage}');background-color:transparent;
        background-size:${backBgSize};background-repeat:${backBgRepeat};background-position:center;`));
    }

    if (module.h === 0.5) {
      const backBg = frontImage
        ? `background-image:url('${frontImage}');background-color:transparent;background-size:100% 100%;background-repeat:no-repeat;`
        : `background:${finishColor};`;
      const bottomImage = resolveModuleAsset(def, "bottom", module.finish) || topImage;

      mod.appendChild(modFace(`position:absolute;left:0;top:${hPx}px;width:${wPx}px;height:${DEPTH}px;transform-origin:center top;transform:rotateX(-90deg);z-index:8;${topBg}`));

      const useRotatedBottomImg = module.finish === 'walnut';
      if (useRotatedBottomImg && bottomImage) {
        const bw = mk('div', `position:absolute;left:0;top:${hPx - 4}px;width:${wPx}px;height:${DEPTH}px;
          transform-origin:center top;transform:rotateX(-90deg) translateZ(2px);z-index:10;
          overflow:hidden;background:${finishColor};
          box-shadow:inset 0 0 0 1px rgba(0,0,0,0.55);`);
        const innerImg = mk('img', `position:absolute;top:50%;left:50%;
          width:${DEPTH}px;height:${wPx}px;
          transform:translate(-50%,-50%) rotate(90deg);
          object-fit:fill;pointer-events:none;`,
          { src: bottomImage });
        bw.appendChild(innerImg);
        mod.appendChild(bw);
      } else {
        const bottomBg = bottomImage
          ? `background-image:url('${bottomImage}');background-color:transparent;background-size:100% 100%;background-repeat:no-repeat;`
          : `background:${finishColor};filter:brightness(0.85);`;
        mod.appendChild(modFace(`position:absolute;left:0;top:${hPx - 4}px;width:${wPx}px;height:${DEPTH}px;transform-origin:center top;transform:rotateX(-90deg) translateZ(2px);z-index:10;${bottomBg}box-shadow:inset 0 0 0 1px rgba(0,0,0,0.55);`));
      }

      mod.appendChild(modFace(`position:absolute;left:0;top:0;width:${wPx}px;height:${hPx}px;transform-origin:center center;transform:translateZ(-${DEPTH}px);z-index:4;${backBg}`));

      const SHELF_WALL = 6;
      const shelfWoodTopDef = moduleDefs.find(m => m.id === 'wood_top');
      const shelfEdgeImage  = resolveModuleAsset(shelfWoodTopDef, 'front', module.finish) || frontImage;
      const shelfEdgeBg = `background-image:url('${shelfEdgeImage}');background-color:transparent;background-size:cover;background-repeat:no-repeat;background-position:center;`;

      mod.appendChild(modFace(`position:absolute;left:${wPx - SHELF_WALL}px;top:0;width:${DEPTH}px;height:${hPx}px;
        transform-origin:left center;transform:rotateY(90deg);z-index:6;
        background-image:url('${sideImage || frontImage}');background-color:transparent;background-size:100% 100%;
        background-repeat:no-repeat;background-position:center;`));
      mod.appendChild(modFace(`position:absolute;left:${-DEPTH + SHELF_WALL}px;top:0;width:${DEPTH}px;height:${hPx}px;
        transform-origin:right center;transform:rotateY(-90deg);z-index:6;
        background-image:url('${sideImage || frontImage}');background-color:transparent;background-size:100% 100%;
        background-repeat:no-repeat;background-position:center;`));

      const topFrame = mk('div', `position:absolute;left:0;top:${-DEPTH}px;width:${wPx}px;height:${DEPTH}px;
        transform-origin:center bottom;transform:rotateX(90deg);z-index:12;
        pointer-events:none;`);
      topFrame.appendChild(mk('div', `position:absolute;left:0;top:0;width:${SHELF_WALL}px;height:${DEPTH}px;${shelfEdgeBg}`));
      topFrame.appendChild(mk('div', `position:absolute;right:0;top:0;width:${SHELF_WALL}px;height:${DEPTH}px;${shelfEdgeBg}`));
      topFrame.appendChild(mk('div', `position:absolute;left:0;top:0;width:${wPx}px;height:${SHELF_WALL}px;${shelfEdgeBg}`));
      topFrame.appendChild(mk('div', `position:absolute;left:0;bottom:0;width:${wPx}px;height:${SHELF_WALL}px;${shelfEdgeBg}`));
      topFrame.appendChild(mk('div', `position:absolute;left:0;top:0;width:${wPx}px;height:${DEPTH}px;
        border:1px solid rgba(0,0,0,0.8);box-sizing:border-box;`));
      topFrame.appendChild(mk('div', `position:absolute;left:${SHELF_WALL}px;top:${SHELF_WALL}px;
        width:${wPx - SHELF_WALL * 2}px;height:${DEPTH - SHELF_WALL * 2}px;
        border:1px solid rgba(0,0,0,0.8);box-sizing:border-box;`));
      mod.appendChild(topFrame);

    } else {
      mod.appendChild(modFace(`position:absolute;left:0;top:${-DEPTH}px;width:${wPx}px;height:${DEPTH}px;transform-origin:center bottom;transform:rotateX(90deg);z-index:5;${topBg}`));
    }

    const knobOverlay = createKnobOverlay(def, module, wPx, hPx);
    if (knobOverlay) mod.appendChild(knobOverlay);

    mod.addEventListener("click", e => { e.stopPropagation(); selectModule(module.id, true); });
    mod.addEventListener("dragstart", e => {
      e.dataTransfer.setData("mona-drag-type", "move");
      e.dataTransfer.setData("mona-module-index", String(index));
      const ghost = createSquareDragGhost(frontImage || def?.thumbnail || "", def?.name || "");
      e.dataTransfer.setDragImage(ghost, 42, 42);
      setTimeout(() => ghost.remove(), 0);
    });

    const removeBtn = mk("button", null, { type: "button", className: "mona-module-remove", innerHTML: "&times;", "aria-label": "Remove" });
    if (module.h === 0.5) {
      removeBtn.style.top = `${-(CELL - 4 - hPx) + 4}px`;
    }
    removeBtn.addEventListener("click", e => {
      e.stopPropagation();
      const removed = state.modules[index];
      restoreTopRailsAround(removed.row, removed.col, removed.w);
      state.modules.splice(index, 1);
      if (state.selectedModuleId === removed.id) state.selectedModuleId = state.modules[0]?.id || null;
      normalizeManualDividerState(); render(); setStatus(T("status_box_removed", "Box removed."));
    });
    mod.appendChild(removeBtn);

    /* Mobile: tap-to-move hints when a module is selected */
    if (("ontouchstart" in window || navigator.maxTouchPoints > 0) &&
        module.id === state.selectedModuleId &&
        module.type !== "wood_top") {
      renderMobileMoveHints(module, index);
    }

    if (!frontImage) {
      const knobLabel = supportsKnob(module.type) && module.knob !== "none" ? ` • ${getKnobDef(module.knob)?.label || module.knob}` : "";
      const label = mk("div", null, { className: "mona-module-label" });
      label.textContent = `${def ? def.name : module.type}${supportsFinish(module.type) ? ` • ${getFinishDef(module.finish)?.label || module.finish}` : ""}${knobLabel}`;
      mod.appendChild(label);
    }
    targetEl.appendChild(mod);
  });
}

function renderGrid() {
  if (!els.grid) return;
  els.grid.innerHTML = "";
  els.grid.style.background = "transparent";
  if (els.gridWrapper) els.gridWrapper.style.background = "transparent";
  const frameColor = CONFIG.frameColor || "#2b2b2b";

  if (!els.grid.dataset.dragInit) {
    els.grid.addEventListener("dragover", e => {
      e.preventDefault();
      const rect = els.grid.getBoundingClientRect();
      const col  = Math.floor((e.clientX - rect.left) / CELL);
      const row  = Math.floor((e.clientY - rect.top)  / CELL);
      els.grid.querySelectorAll(".mona-cell").forEach(c => c.classList.toggle("drag-over",
        parseInt(c.style.left, 10) === col * CELL && parseInt(c.style.top, 10) === row * CELL));
    });
    els.grid.addEventListener("dragleave", e => {
      if (!els.grid.contains(e.relatedTarget)) els.grid.querySelectorAll(".mona-cell").forEach(c => c.classList.remove("drag-over"));
    });
    els.grid.addEventListener("drop", e => {
      e.preventDefault();
      els.grid.querySelectorAll(".mona-cell").forEach(c => c.classList.remove("drag-over"));
      const rect     = els.grid.getBoundingClientRect();
      const col      = Math.floor((e.clientX - rect.left) / CELL);
      const rawY     = (e.clientY - rect.top) / CELL;
      const typeId   = e.dataTransfer.getData("text/plain");
      const def      = getModuleDef(typeId);
      const dragType = e.dataTransfer.getData("mona-drag-type");
      if (dragType === "move") {
        const mi   = Number(e.dataTransfer.getData("mona-module-index"));
        const mDef = getModuleDef(state.modules[mi]?.type);
        moveModule(mi, mDef?.height === 0.5 ? Math.floor(rawY) + 0.5 : Math.floor(rawY), col);
      } else {
        addModule(typeId, def?.height === 0.5 ? Math.floor(rawY) + 0.5 : Math.floor(rawY), col);
      }
    });
    els.grid.addEventListener("click", e => {
      if (e.target === els.grid || e.target.classList.contains("mona-cell")) {
        if (window.MONA_PENDING_PLACEMENT) {
          window.MONA_PENDING_PLACEMENT = null;
          document.querySelectorAll('.mona-mobile-library-item').forEach(function(el) {
            el.classList.remove('is-selected');
          });
          clearMobilePlacementHints();
        }
        clearSelection();
        renderGrid();
      }
    });
    els.grid.dataset.dragInit = "true";
  }

  for (let row = 0; row < state.height; row++)
    for (let col = 0; col < state.width; col++)
      els.grid.appendChild(mk("div", `position:absolute;left:${col * CELL}px;top:${row * CELL}px;width:${CELL}px;height:${CELL}px;background:transparent;`, { className: "mona-cell" }));

  buildGrid(els.grid, frameColor, state.showMeasurements);

  const divBtnCss = (l, t) => `position:absolute;left:${l}px;top:${t}px;z-index:9999;pointer-events:auto;`;

  /* ─── Vertical divider X/+ buttons ──────────────────────────────────────── */
  for (let row = 0; row < state.height; row++)
    for (let col = 0; col < state.width - 1; col++) {
      const isVerticalRemoved = !!state.removedVertical[keyV(row, col)];
      const btn     = mk("button", divBtnCss((col + 1) * CELL - 10, row * CELL + CELL / 2 - 10), { type: "button", className: "mona-divider-btn", innerHTML: isVerticalRemoved ? "+" : "×" });
      const blocked = state.modules.some(m => m.type !== "wood_top" && row >= Math.floor(m.row) && row < Math.ceil(m.row + m.h) && col >= m.col - 1 && col <= m.col + m.w - 1);
      /* "Open at this row" means: this row's cell in that column is either
         shortened away (no ceiling) or is part of a tall opening (one of its
         bounding rails removed but rail above intact). The X button hides if
         either side column is in such an "open" state at this row. */
      const colOpenAtRow = (c) => {
        /* Shortened away — no cell at this row */
        if (!columnHasCellAtRow(c, row)) return true;
        /* Tall opening: rail above (row r) or below (row r+1) is removed
           but the cell still has a ceiling somewhere above */
        if (row > 0 && horizontalRailRemoved(row, c)) return true;
        if (row < state.height - 1 && horizontalRailRemoved(row + 1, c)) return true;
        return false;
      };
      const inOpenArea = colOpenAtRow(col) || colOpenAtRow(col + 1);
      const wideAbove = state.modules.some(m =>
        m.type !== "wood_top" &&
        m.w >= 2 &&
        Math.ceil(m.row + m.h) <= row &&
        col >= m.col && col < m.col + m.w - 1
      );
      let shouldHide = blocked || inOpenArea || wideAbove;
      if (!isVerticalRemoved && !shouldHide) {
        if (!canToggleVerticalDivider(row, col)) shouldHide = true;
      }
      btn.style.display = shouldHide ? "none" : "flex";
      btn.addEventListener("click", () => toggleVerticalDivider(row, col));
      els.grid.appendChild(btn);
    }

  /* ─── Top X/+ buttons (one per top group) ───────────────────────────────── */
  if (state.height > 1) {
    let topCol = 0;
    while (topCol < state.width) {
      const group = getTopGroup(topCol);
      const groupSpan = group.endCol - group.startCol + 1;
      const isTopRemoved = !!state.removedTop[`top_${group.startCol}`];
      const centerX = (group.startCol + groupSpan / 2) * CELL;
      const btn = mk("button", divBtnCss(centerX - 10, -10), { type: "button", className: "mona-divider-btn", innerHTML: isTopRemoved ? "+" : "×" });
      const blocked = state.modules.some(m => m.row === 0 && m.col <= group.endCol && m.col + m.w - 1 >= group.startCol);
      let topHide = blocked;
      /* When this is an X (would shorten), hide it if shortening this group
         would be rejected — so only clickable X's are visible. + (restore)
         buttons always stay shown. */
      if (!topHide && !isTopRemoved) {
        /* Rule: at least one other column must stay full height. */
        let othersFullHeight = 0;
        for (let c = 0; c < state.width; c++) {
          if (c >= group.startCol && c <= group.endCol) continue;
          if (isColumnFullHeight(c)) othersFullHeight++;
        }
        if (othersFullHeight === 0) topHide = true;
        /* Rule: lateral stability. */
        if (!topHide) {
          const simTop = Object.assign({}, state.removedTop);
          for (let c = group.startCol; c <= group.endCol; c++) simTop[`top_${c}`] = true;
          if (!layoutSatisfiesStability(simTop, state.removedHorizontal)) topHide = true;
        }
        /* Rule: shortening above a wide opening on a side outside the group. */
        if (!topHide) {
          for (let c = group.startCol; c <= group.endCol && !topHide; c++) {
            const leftKey  = keyV(0, c - 1);
            const rightKey = keyV(0, c);
            const leftExposes = (c - 1 >= 0) && (c - 1 < group.startCol)
              && !!state.removedVertical[leftKey] && !state.autoMergedTopDividers[leftKey];
            const rightExposes = (c < state.width - 1) && (c + 1 > group.endCol)
              && !!state.removedVertical[rightKey] && !state.autoMergedTopDividers[rightKey];
            if (leftExposes || rightExposes) topHide = true;
          }
        }
      }
      btn.style.display = topHide ? "none" : "flex";
      btn.addEventListener("click", () => toggleTopSegment(group.startCol));
      els.grid.appendChild(btn);
      topCol = group.endCol + 1;
    }
  }

  /* ─── Inner horizontal rail X/+ buttons ─────────────────────────────────── */
  if (state.height > 1) {
    for (let row = 1; row < state.height; row++) {
      /* Never allow removing the rail directly above the bottom row */
      if (row === state.height - 1) continue;
      for (let col = 0; col < state.width; col++) {
        /* Block if a module crosses this rail, or sits with the rail as its
           top edge, or sits with the rail as its bottom edge. Boxes must
           always be fully surrounded by their bounding rails. */
        const blocked = state.modules.some(m => {
          if (m.type === "wood_top") return false;
          if (col < m.col || col >= m.col + m.w) return false;
          /* Rail crosses the box body */
          if (row > m.row && row < m.row + m.h + (m.h === 0.5 ? 1 : 0)) return true;
          /* Rail is the box's bottom edge — always blocked */
          if (row === Math.ceil(m.row + m.h)) return true;
          /* Rail is the box's top edge:
             - For shelf modules (h=0.5), allow toggling — removing this rail
               removes the shelf surface above the shelf module without removing
               the shelf module itself.
             - For all other boxes, block (every full box must keep its top rail). */
          if (row === Math.floor(m.row)) {
            if (m.h === 0.5) return false;
            return true;
          }
          return false;
        });
        if (blocked) continue;
        const isRemoved = horizontalRailRemoved(row, col);
        if (!isRemoved) {
          if (validateInnerRailRemoval(row, col) !== null) continue;
        }
        const btn = mk("button",
          divBtnCss(col * CELL + CELL / 2 - 10, row * CELL - 10),
          { type: "button", className: "mona-divider-btn", innerHTML: isRemoved ? "+" : "×" }
        );
        btn.addEventListener("click", () => {
          if (isRemoved) {
            delete state.removedHorizontal[horizontalRailKey(row, col)];
            setStatus(T("status_rail_restored", "Rail restored."));
          } else {
            /* Skip the strict validation when this rail sits directly on top
               of a shelf module — that case is always allowed. */
            const isAboveShelfModule = state.modules.some(m =>
              m.h === 0.5 &&
              Math.floor(m.row) === row &&
              col >= m.col && col < m.col + m.w
            );
            if (!isAboveShelfModule) {
              const reason = validateInnerRailRemoval(row, col);
              if (reason) { setStatus(reason); return; }
            }
            state.removedHorizontal[horizontalRailKey(row, col)] = true;
            /* Clear any module that would now cross this removed rail —
               but never remove a shelf module just because the rail above
               it (which is the shelf module's top edge) was removed. */
            state.modules = state.modules.filter(m => {
              if (m.type === "wood_top") return true;
              if (col < m.col || col >= m.col + m.w) return true;
              /* Shelf module sitting with this rail as its top edge: keep it */
              if (m.h === 0.5 && Math.floor(m.row) === row) return true;
              if (m.row < row && row < m.row + m.h) return false;
              return true;
            });
            if (state.selectedModuleId && !getModuleById(state.selectedModuleId)) {
              state.selectedModuleId = state.modules[0]?.id || null;
            }
            setStatus(T("status_rail_removed", "Rail removed."));
          }
          render();
        });
        els.grid.appendChild(btn);
      }
    }
  }
}

function applyTransform() {
  if (!els.gridWrapper) return;
  els.gridWrapper.style.transformStyle = "preserve-3d";
  const isMobile = window.innerWidth <= 960;
  let scale = 1;
  if (isMobile) {
    const shell = document.querySelector(".mona-canvas-shell");
    const availableW = shell ? shell.clientWidth  : window.innerWidth;
    const availableH = shell ? shell.clientHeight : 300;
    const padW = 20;
    const padH = 100;
    const gridChromeH = 80;
    const radX = (state.rotX || 0) * Math.PI / 180;
    const radY = (state.rotY || 0) * Math.PI / 180;
    /* Use the largest dimension as the bounding-box reference so that
       configurations of the same MAX size scale the same way. This means
       a 4×6 grid looks the same visual size as a 6×6 grid (the 6 is the
       limiting side in both cases). */
    const maxDim = Math.max(state.width, state.height);
    const gridFlatW = maxDim * CELL;
    const gridFlatH = maxDim * CELL + gridChromeH;
    /* Projected dimensions when rotated. */
    const projW = Math.abs(gridFlatW * Math.cos(radY)) + Math.abs(DEPTH * 2 * Math.sin(radY));
    const projH = Math.abs(gridFlatH * Math.cos(radX)) + Math.abs(DEPTH * 2 * Math.sin(radX));
    /* Extra safety: 3/4 perspective view adds extra visual width via foreshortening
       that's hard to compute exactly. Apply a small safety factor when rotated. */
    const rotated = Math.abs(state.rotY) > 5 || Math.abs(state.rotX) > 5;
    const safetyFactorW = rotated ? 0.92 : 1.0;
    const safetyFactorH = rotated ? 0.95 : 1.0;
    const fitW = ((availableW - padW) * safetyFactorW) / projW;
    const fitH = ((availableH - padH) * safetyFactorH) / projH;
    scale = Math.max(0.18, Math.min(fitW, fitH, 1.4));

    els.gridWrapper.style.bottom = 'auto';
    els.gridWrapper.style.transform = `translate(-50%, -50%) scale(${scale}) rotateX(${state.rotX}deg) rotateY(${state.rotY}deg)`;
  } else {
    els.gridWrapper.style.transform = `scale(${scale}) rotateX(${state.rotX}deg) rotateY(${state.rotY}deg)`;
  }
  els.gridWrapper.style.transformOrigin = "center center";
}

/* Remove wood tops whose surface row no longer matches their column's
   actual top surface row (e.g., after a rail was restored or further
   shortened). Each wood top must sit on the visible top surface of every
   column it spans. */
function reconcileWoodTops() {
  const before = state.modules.length;
  state.modules = state.modules.filter(m => {
    if (m.type !== "wood_top") return true;
    for (let c = m.col; c < m.col + m.w; c++) {
      if (getColumnTopSurfaceRow(c) !== m.row) return false;
    }
    return true;
  });
  if (state.modules.length !== before && state.selectedModuleId && !getModuleById(state.selectedModuleId)) {
    state.selectedModuleId = state.modules[0]?.id || null;
  }
}

function render(triggerForce3D = false) {
  state.modules.forEach(normalizeModuleOptions);
  reconcileWoodTops();
  renderLibrary();
  ensureGlobalFinishControl();
  ensureGlobalKnobControl();
  renderElementsList();
  renderInspector();
  renderGrid();
  renderPriceBreakdown();
  applyTransform();
  updateDimensionsBadge();
  updateAnchorNote();

  /* Only re-run the 3D recovery fix when explicitly requested — e.g. after
     the async currency fetch resolves on a cold mobile connection, which is
     the specific WebKit race this guards against. Running it after every
     interaction-driven render (clicks, drags, finish/knob changes) added a
     synchronous DOM detach/reattach + forced reflow + extra rAF cycle to
     every single tap, which was likely hurting INP. */
  if (triggerForce3D && window.innerWidth <= 960 && typeof window.MONA_FORCE_3D === "function") {
    requestAnimationFrame(() => requestAnimationFrame(window.MONA_FORCE_3D));
  }
}

function initToolColumn() {
  if (!els.toolColumn) return;
  els.toolColumn.innerHTML = "";
  const toolBtn = (svg, tooltip, onClick) => {
    const btn = mk("button", null, { type: "button", className: "mona-tool-btn", innerHTML: svg });
    const tip = mk("span", `position:absolute;bottom:calc(100% + 8px);left:50%;transform:translateX(-50%);
      background:#111;color:#fff;font-size:11px;padding:4px 8px;border-radius:4px;white-space:nowrap;
      pointer-events:none;opacity:0;transition:opacity .15s;z-index:100;`);
    tip.textContent = tooltip;
    btn.appendChild(tip);
    btn.addEventListener("mouseenter", () => tip.style.opacity = "1");
    btn.addEventListener("mouseleave", () => tip.style.opacity = "0");
    btn.addEventListener("click", () => onClick(btn));
    return btn;
  };
  const rulerSVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21.3 8.7L15.3 2.7a1 1 0 00-1.4 0L2.7 13.9a1 1 0 000 1.4l6 6a1 1 0 001.4 0L21.3 10.1a1 1 0 000-1.4z"/><path d="M7 17l-1-1M10 14l-2-2M13 11l-1-1M16 8l-2-2"/></svg>`;
  els.toolColumn.appendChild(toolBtn(rulerSVG, (window.MONA_T && window.MONA_T.tooltip_show_measurements) || "Show measurements", (btn) => {
    state.showMeasurements = !state.showMeasurements;
    btn.classList.toggle("is-active", state.showMeasurements);
    render();
  }));
}

function updateDimensionsBadge() {
  const wCm = state.width * 40;
  const hCm = state.height * 40 + 10;
  const wEl = document.getElementById("mona-dim-w");
  const hEl = document.getElementById("mona-dim-h");
  if (wEl) wEl.textContent = wCm;
  if (hEl) hEl.textContent = hCm;
}

let anchorModalShownForTall = false;
function updateAnchorNote() {
  const modal = document.getElementById("mona-anchor-modal");
  if (!modal) return;
  /* Threshold: 5 rows (210cm) or taller → recommend wall anchor. */
  const THRESHOLD_ROWS = 5;
  const isTall = state.height >= THRESHOLD_ROWS;

  if (isTall && !anchorModalShownForTall) {
    /* Just crossed into tall territory — show the modal once. */
    const textEl = document.getElementById("mona-anchor-modal-text");
    if (textEl) textEl.textContent = (window.MONA_T && window.MONA_T.wall_anchor_note) || "";
    modal.classList.add("is-open");
    anchorModalShownForTall = true;
  } else if (!isTall) {
    /* Dropped back below the threshold — reset so it can show again
       if they go tall a second time, and make sure it's closed. */
    anchorModalShownForTall = false;
    modal.classList.remove("is-open");
  }
}

async function addToCart() {
  if (!els.addToCart) return;
  els.addToCart.disabled = true;
  setStatus(T("status_adding_cart", "Adding to cart..."));

  const buildId    = `mona_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
  const buildLabel = `My MONA ${state.width}×${state.height}`;
  const buildState = encodeBuildState();

  /* Cloudinary upload happens AFTER cart-add succeeds, in the background.
     This way the user sees the cart open immediately instead of waiting
     4-5 seconds for snapshot generation + uploads. See uploadAndPatchPreview() below. */
  try {
    const q     = computeStructuralQuantities();
    const items = [];

    const baseProps = {
      "_build_id":    buildId,
      "_build_label": buildLabel,
      "_build_state": buildState,
      "_preview_image": "",          /* patched in by uploadAndPatchPreview() */
      "_preview_composite": ""       /* patched in by uploadAndPatchPreview() */
    };

    const BOX_PRODUCTS = window.MONA_BOX_PRODUCTS || {};

    function findBoxVariantId(moduleTypeId, finishValue, knobValue) {
      const product = BOX_PRODUCTS[moduleTypeId];
      if (!product || !product.variants) return null;
      const finishLabelMap = { walnut: "Walnut", oak: "Oak", dark_oak: "Dark Oak", black: "Black", c: "Oak", d: "Dark Oak" };
      const knobLabelMap   = { yellow: "Yellow", black: "Black", gray: "Gray", none: "Yellow" };
      const wantedFinish = finishLabelMap[(finishValue || "walnut").toLowerCase()] || "Walnut";
      const wantedKnob   = knobLabelMap[(knobValue || "none").toLowerCase()] || "Yellow";
      const optionNames = (product.options || []).map(o =>
        (typeof o === "string" ? o : o.name || "").toLowerCase()
      );
      const finishIdx = optionNames.findIndex(n => n.includes("finish") || n.includes("color") || n.includes("colour"));
      const knobIdx   = optionNames.findIndex(n => n.includes("knob"));
      const match = product.variants.find(v => {
        const opts = [v.option1, v.option2, v.option3];
        const fOk  = finishIdx < 0 || opts[finishIdx] === wantedFinish;
        const kOk  = knobIdx   < 0 || opts[knobIdx]   === wantedKnob;
        return fOk && kOk;
      });
      return match ? match.id : (product.variants[0]?.id || null);
    }

    const pushStructural = (variantId, qty) => {
      if (qty > 0 && variantId) {
        items.push({ id: variantId, quantity: qty, properties: { ...baseProps } });
      }
    };
    pushStructural(STRUCT.uFrame?.variantId,        q.uFrames);
    pushStructural(STRUCT.connector?.variantId,     q.connectors);
    pushStructural(STRUCT.baseRectangle?.variantId, q.baseRects);
    pushStructural(STRUCT.shelfPanel?.variantId,    q.shelfPanels);
    pushStructural(STRUCT.foot?.variantId,          q.feet);
    /* Configuration product — one per build, carries shipping/setup. */
    const configProduct = window.MONA_CONFIG_PRODUCT;
    if (configProduct && configProduct.variantId) {
      items.push({ id: configProduct.variantId, quantity: 1, properties: { ...baseProps } });
    }

    state.modules.forEach(m => {
      const variantId = findBoxVariantId(m.type, m.finish, m.knob);
      if (!variantId) return;
      const props = { ...baseProps,
        "Position": `Row ${Math.floor(m.row) + 1}, Column ${m.col + 1}`
      };
      if (supportsFinish(m.type)) props["Finish"] = getFinishDef(m.finish)?.label || m.finish;
      if (supportsKnob(m.type) && m.knob !== "none") props["Knob"] = getKnobDef(m.knob)?.label || m.knob;
      if (m.h === 0.5 && m.removeTopShelf) props["Top shelf"] = "Removed";
      items.push({ id: variantId, quantity: 1, properties: props });
    });

    if (items.length === 0) {
      setStatus(T("status_nothing_to_add", "Nothing to add to cart."));
      els.addToCart.disabled = false;
      return;
    }

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      console.error("Cart add failed:", err);
      throw new Error(err.description || "Cart add failed");
    }

    setStatus(T("status_added_cart", "Added to cart."));

    /* Fire the snapshot + Cloudinary upload in the background.
       Doesn't block the drawer from opening — runs silently and
       patches _preview_image onto the line items when finished. */
    uploadAndPatchPreview(buildId).catch(err =>
      console.warn('Preview upload failed (non-fatal):', err)
    );

    /* Refresh the cart drawer + icon bubble without reloading the page.
       Strategy: pull /cart.js immediately for the count (instant), then
       fetch / as HTML (the only fetch that reliably contains a fresh
       drawer for Atelier on the configurator page) and swap the drawer
       contents in. We pause briefly first so Shopify's session has
       committed the cart-add before we ask for fresh HTML. */
    try {
      /* Step 1 (fast): update the cart bubble count from /cart.js.
         The bubble counts unique _build_id groups as 1 (matching the
         Liquid math in snippets/cart-icon-bubble.liquid), so we replicate
         that grouping client-side instead of using cart.item_count. */
      const cartJson = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .catch(() => ({ items: [], item_count: 0 }));

      const seenBuilds = new Set();
      let displayCount = 0;
      (cartJson.items || []).forEach(item => {
        const buildId = item.properties && item.properties._build_id;
        if (buildId) {
          if (!seenBuilds.has(buildId)) {
            seenBuilds.add(buildId);
            displayCount += 1;
          }
        } else {
          displayCount += item.quantity || 0;
        }
      });

      /* Update the bubble count text — skip any bubble inside the cart drawer
         itself, as that's a separate element that shouldn't be touched. */
      document.querySelectorAll('[ref="cartBubbleCount"], [data-testid="cart-bubble"]').forEach(el => {
        if (el.closest('dialog.cart-drawer__dialog')) return;
        el.textContent = displayCount > 0 ? String(displayCount) : '';
        if (displayCount > 0) el.classList.remove('hidden');
        else el.classList.add('hidden');
      });

      document.querySelectorAll('[ref="cartBubbleText"] .visually-hidden, #cart-bubble-text .visually-hidden').forEach(el => {
        if (el.closest('dialog.cart-drawer__dialog')) return;
        const label = (el.textContent.split(':')[0] || '').trim();
        el.textContent = `${label}: ${displayCount}`;
      });

      document.querySelectorAll('[ref="cartBubble"], .cart-bubble').forEach(el => {
        if (el.closest('dialog.cart-drawer__dialog')) return;
        if (displayCount > 0) el.classList.remove('visually-hidden');
        else el.classList.add('visually-hidden');
      });

      /* Step 2: brief delay, then fetch / as HTML for fresh drawer markup.
         Without the delay, Shopify can return cached drawer HTML that
         doesn't yet reflect the just-added items. */
      await new Promise(r => setTimeout(r, 250));

      const homeRes = await fetch('/', {
        headers: { 'Accept': 'text/html' },
        cache: 'no-store'
      });
      const homeHtml = await homeRes.text();
      const parsed = new DOMParser().parseFromString(homeHtml, 'text/html');
      const newDialog = parsed.querySelector('dialog.cart-drawer__dialog');
      const oldDialog = document.querySelector('dialog.cart-drawer__dialog');

      if (newDialog && oldDialog) {
        oldDialog.innerHTML = newDialog.innerHTML;
      } else if (newDialog && !oldDialog) {
        document.body.appendChild(newDialog.cloneNode(true));
      }
    } catch (e) {
      console.warn('Cart refresh failed, falling back to reload', e);
      try { sessionStorage.setItem('mona_open_cart_after_reload', '1'); } catch (_) {}
      window.location.reload();
      return;
    }

    /* Open the drawer — small delay so the swapped innerHTML has had time
       to commit before showModal() reads it. Without this, iOS Safari can
       sometimes open the drawer with the prior (empty) DOM. */
    setTimeout(() => {
      const drawer = document.querySelector('dialog.cart-drawer__dialog');
      if (drawer && typeof drawer.showModal === 'function') {
        try { drawer.showModal(); } catch (e) { drawer.show && drawer.show(); }
      }
    }, 50);

    els.addToCart.disabled = false;
  } catch (err) {
    console.error(err);
    setStatus(T("status_add_failed", "Could not add to cart. Please try again."));
    els.addToCart.disabled = false;
  }
}

/* Generates the snapshot, uploads to Cloudinary, then patches the
   _preview_image property onto every just-added line item via
   /cart/change.js. Completely non-blocking — failures are silent. */
async function uploadAndPatchPreview(buildId) {
  /* Lazy-load html-to-image if not already on the page */
  if (!window.htmlToImage) {
    await new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/html-to-image@1.11.11/dist/html-to-image.js';
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  const source = document.querySelector('.mona-canvas-shell');
  if (!source) return;

  /* Hide UI chrome that shouldn't appear in the snapshot */
  const hideSelectors = [
    '.mona-module-remove', '.mona-divider-btn',
    '#mona-rotate-left', '#mona-rotate-right',
    '.mona-tool-btn', '.mona-mobile-library-strip',
    '.mona-cell-hint', '.mona-move-hint',
    '#mona-dimensions-badge', '.mona-canvas-shell > button'
  ];
  const hidden = document.querySelectorAll(hideSelectors.join(','));
  hidden.forEach(el => el.style.visibility = 'hidden');
  const originalStyle = source.getAttribute('style') || '';
  source.style.background = '#ffffff';

 const savedRotX = state.rotX;
  const savedRotY = state.rotY;
  const wrapper = els.gridWrapper;
  const savedTransition = wrapper ? wrapper.style.transition : '';
  if (wrapper) wrapper.style.transition = 'none';

  const views = [
    { label: 'Front', rotX: -0.001, rotY: 0.001 },
    { label: 'Top',   rotX: -45,    rotY: 0.001 }
  ];

  const captures = [];
  let compositeDataUrl = '';

  try {
    for (const view of views) {
      state.rotX = view.rotX;
      state.rotY = view.rotY;
      applyTransform();
      if (wrapper) void wrapper.offsetWidth;
      await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));

      const viewDataUrl = await window.htmlToImage.toJpeg(source, {
        backgroundColor: '#ffffff',
        pixelRatio: 1,
        quality: 0.85,
        cacheBust: false,
        skipFonts: true,
        style: { background: '#ffffff' }
      });
      captures.push({ label: view.label, dataUrl: viewDataUrl });
    }

    /* Composite Front + Top onto a single canvas with labels */
    const loadedImages = await Promise.all(captures.map(c => new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = c.dataUrl;
    })));

    const PANEL_W = 600, PANEL_H = 600, LABEL_H = 40, PADDING = 20, cols = 2;
    const totalW = cols * PANEL_W + (cols + 1) * PADDING;
    const totalH = PANEL_H + LABEL_H + PADDING * 2;
    const composite = document.createElement('canvas');
    composite.width = totalW;
    composite.height = totalH;
    const ctx = composite.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, totalW, totalH);
    ctx.fillStyle = '#111';
    ctx.font = 'bold 18px Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    loadedImages.forEach((img, i) => {
      const x = PADDING + i * (PANEL_W + PADDING);
      const y = PADDING + LABEL_H;
      ctx.fillStyle = '#111';
      ctx.fillText(captures[i].label, x + PANEL_W / 2, PADDING + LABEL_H / 2);
      const sc = Math.min(PANEL_W / img.width, PANEL_H / img.height);
      const dW = img.width * sc, dH = img.height * sc;
      ctx.drawImage(img, x + (PANEL_W - dW) / 2, y + (PANEL_H - dH) / 2, dW, dH);
    });
    compositeDataUrl = composite.toDataURL('image/jpeg', 0.85);
  } finally {
    /* Always restore the UI, even on capture failure */
    source.setAttribute('style', originalStyle);
    hidden.forEach(el => el.style.visibility = '');
    state.rotX = savedRotX;
    state.rotY = savedRotY;
    applyTransform();
    if (wrapper) wrapper.style.transition = savedTransition;
  }

  /* Upload a single composite image (front + top view) — used both for the
     cart thumbnail and for fulfillment / admin reference. */
  const compBlob = await (await fetch(compositeDataUrl)).blob();
  const compFD = new FormData();
  compFD.append('file', compBlob);
  compFD.append('upload_preset', CLOUDINARY.uploadPreset);
  compFD.append('public_id', buildId);
  const compRes = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUDINARY.cloudName}/image/upload`,
    { method: 'POST', body: compFD }
  );
  if (!compRes.ok) return;
  const compData = await compRes.json();
  const previewUrl = compData.secure_url || '';
  const compositeUrl = previewUrl;

  /* Patch the just-added line items with the preview URLs.
     /cart/change.js accepts a line item key + new properties, and
     replaces them. We merge with existing props to preserve Position,
     Finish, etc. */
  try {
    const cartJson = await fetch('/cart.js').then(r => r.json());
    const matching = (cartJson.items || []).filter(i =>
      i.properties && i.properties._build_id === buildId
    );
    for (const lineItem of matching) {
      const mergedProps = { ...(lineItem.properties || {}),
        _preview_image: MONA_LOGO_URL,    /* cart drawer thumbnail = MONA logo */
        _preview_composite: previewUrl    /* order admin / fulfillment = front+top composite */
      };
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: lineItem.key,
          quantity: lineItem.quantity,
          properties: mergedProps
        })
      });
    }
  } catch (e) { /* silent — order still has all the config data via _build_state */ }
}

[
  ["widthMinus",  "width",  -1, 1],
  ["widthPlus",   "width",   1, MAX_W],
  ["heightMinus", "height", -1, 1],
  ["heightPlus",  "height",  1, MAX_H]
].forEach(([key, dim, delta, limit]) => {
  els[key]?.addEventListener("click", () => {
    if (delta < 0 ? state[dim] > limit : state[dim] < limit) {
      /* Block the change if it would result in a 1×1 grid (total cells < 2) */
      const nextW = dim === "width"  ? state.width  + delta : state.width;
      const nextH = dim === "height" ? state.height + delta : state.height;
      if (nextW * nextH < 2) {
        setStatus(T("status_min_two_cells", "Grid must have at least 2 cells."));
        return;
      }
      state[dim] += delta; clampDimensions(); render(); setStatus(T("status_dimensions_updated", "Dimensions updated."));
    }
  });
});

els.openCustomize?.addEventListener("click", () => {
  setRightPanelMode("customize");
  if (!state.selectedModuleId && state.modules.length) selectModule(state.modules[0].id, true);
});
els.openPrice?.addEventListener("click", () => setRightPanelMode("price"));

els.boxFinish?.addEventListener("change", () => {
  const m = getSelectedModule();
  if (!m || !supportsFinish(m.type)) return;
  m.finish = els.boxFinish.value; render(); setStatus(T("status_finish_updated", "Box finish updated."));
});
els.boxKnob?.addEventListener("change", () => {
  const m = getSelectedModule();
  if (!m || !supportsKnob(m.type)) return;
  m.knob = els.boxKnob.value; render(); setStatus(T("status_knob_updated", "Knob updated."));
});
els.resetLayout?.addEventListener("click", () => {
  state.width = 4;
  state.height = 4;
  state.removedVertical = {};
  state.removedTop = {};
  state.removedHorizontal = {};
  state.leftTrim = {};
  state.rightTrim = {};
  state.autoMergedTopDividers = {};
  state.modules = [];
  state.selectedModuleId = null;
  state.rotX = -0.001;
  state.rotY = 0.001;
  clampDimensions();
  render();
  setStatus(T("status_layout_reset", "Layout reset."));
});

(function initAnchorModal() {
  const modal = document.getElementById("mona-anchor-modal");
  const btn = document.getElementById("mona-anchor-modal-btn");
  if (!modal || !btn) return;
  btn.addEventListener("click", function() {
    modal.classList.remove("is-open");
  });
  /* Also close on backdrop click. */
  modal.addEventListener("click", function(e) {
    if (e.target === modal) modal.classList.remove("is-open");
  });
})();

[["rotateLeft", 45, 0.001], ["rotateRight", -45, 0.001]].forEach(([key, step, reset]) => {
  els[key]?.addEventListener("click", () => {
    if (step > 0) {
      state.rotY = state.rotY >= 45 ? reset : Math.min(45, state.rotY + step);
    } else {
      state.rotY = state.rotY <= -45 ? reset : Math.max(-45, state.rotY + step);
    }
    applyTransform();
  });
});

els.addToCart?.addEventListener("click", addToCart);

window.MONA_TILT_UP = function() {
  state.rotX = state.rotX <= -40 ? 0 : Math.max(-40, state.rotX - 20);
  applyTransform();
};
window.MONA_TILT_DOWN = function() {
  state.rotX = state.rotX >= 0 ? -20 : state.rotX + 20;
  applyTransform();
};

(function initTiltButtons() {
  const shell = document.querySelector(".mona-canvas-shell");
  if (!shell) return;
  const base = `position:absolute;left:50%;transform:translateX(-50%);z-index:30;width:32px;height:32px;
    border:1px solid #111;border-radius:50%;background:#fff;cursor:pointer;font-size:14px;
    display:flex;align-items:center;justify-content:center;`;
  const tiltBtns = [
    { symbol: "↑", title: "Tilt up",   pos: "top:10px;",    action: () => { state.rotX = state.rotX <= -40 ? 0 : Math.max(-40, state.rotX - 20); } },
    { symbol: "↓", title: "Tilt down", pos: "bottom:10px;", action: () => { state.rotX = state.rotX >= 0  ? -20 : state.rotX + 20; } }
  ];
  tiltBtns.forEach(({ symbol, title, pos, action }) => {
    const btn = mk("button", base + pos, { type: "button", innerHTML: symbol, title });
    btn.addEventListener("click", () => { action(); applyTransform(); });
    shell.appendChild(btn);
  });
})();

function clearMobilePlacementHints() {
  document.querySelectorAll('.mona-cell-hint').forEach(el => el.remove());
}

function renderMobileMoveHints(module, moduleIndex) {
  document.querySelectorAll('.mona-move-hint').forEach(el => el.remove());
  const grid = document.getElementById('mona-grid');
  if (!grid) return;
  const def = getModuleDef(module.type);
  if (!def) return;

  if (module.type === "wood_top") {
    for (let c = 0; c <= state.width - module.w; c++) {
      if (c === module.col) continue;
      let valid = true;
      for (let cc = c; cc < c + module.w; cc++) {
        if (getColumnTopSurfaceRow(cc) !== module.row) { valid = false; break; }
        if (state.modules.some((o, i) => i !== moduleIndex && o.type === "wood_top" && cc >= o.col && cc < o.col + o.w)) {
          valid = false;
          break;
        }
      }
      if (!valid) continue;
      const hint = mk("div", `position:absolute;
        left:${c * CELL + 2}px;
        top:${module.row * CELL + 2}px;
        width:${module.w * CELL - 4}px;
        height:${CELL - 4}px;
        background: rgba(74, 158, 255, 0.10);
        outline: 2px dashed rgba(74, 158, 255, 0.55);
        outline-offset: -2px;
        border-radius: 4px;
        z-index: 25;
        cursor: pointer;
        touch-action: manipulation;
        mix-blend-mode: multiply;`,
        { className: "mona-move-hint" });
      const targetCol = c;
      const targetRow = module.row;
      hint.addEventListener("click", function(e) {
        e.stopPropagation();
        moveModule(moduleIndex, targetRow, targetCol);
        document.querySelectorAll('.mona-move-hint').forEach(el => el.remove());
      });
      grid.appendChild(hint);
    }
    return;
  }

  const isShelf = module.h === 0.5;
  const startR = isShelf ? 0.5 : 0;
  const step = isShelf ? 1 : 1;
  for (let r = startR; r <= state.height - module.h; r += step) {
    for (let c = 0; c <= state.width - module.w; c++) {
      if (r === module.row && c === module.col) continue;
      if (!canPlaceAt(r, c, module.w, module.h, moduleIndex, module.type)) continue;
      const hint = mk("div", `position:absolute;
        left:${c * CELL + 2}px;
        top:${r * CELL + 2}px;
        width:${module.w * CELL - 4}px;
        height:${module.h * CELL - 4}px;
        background: rgba(74, 158, 255, 0.10);
        outline: 2px dashed rgba(74, 158, 255, 0.55);
        outline-offset: -2px;
        border-radius: 4px;
        z-index: 25;
        cursor: pointer;
        touch-action: manipulation;
        mix-blend-mode: multiply;`,
        { className: "mona-move-hint" });
      const targetRow = r;
      const targetCol = c;
      hint.addEventListener("click", function(e) {
        e.stopPropagation();
        moveModule(moduleIndex, targetRow, targetCol);
        document.querySelectorAll('.mona-move-hint').forEach(el => el.remove());
      });
      grid.appendChild(hint);
    }
  }
}

function renderMobilePlacementHints(def) {
  clearMobilePlacementHints();
  const grid = document.getElementById('mona-grid');
  if (!grid) return;

  if (def.id === "wood_top") {
    for (let c = 0; c < state.width; c++) {
      const surfaceRow = getColumnTopSurfaceRow(c);
      if (surfaceRow === null) continue;
      const occupied = state.modules.some(m => m.type === "wood_top" && c >= m.col && c < m.col + m.w);
      if (occupied) continue;
      const hint = mk("div", `position:absolute;
        left:${c * CELL + 2}px;
        top:${surfaceRow * CELL + 2}px;
        width:${CELL - 4}px;
        height:${CELL - 4}px;
        background: rgba(74, 158, 255, 0.18);
        border: 2px dashed rgba(74, 158, 255, 0.7);
        border-radius: 4px;
        z-index: 25;
        cursor: pointer;
        touch-action: manipulation;`,
        { className: "mona-cell-hint" });
      const targetCol = c;
      const targetRow = surfaceRow;
      const placeHandler = function(e) {
        e.stopPropagation();
        e.preventDefault();
        addModule(def.id, targetRow, targetCol);
        window.MONA_PENDING_PLACEMENT = null;
        document.querySelectorAll('.mona-mobile-library-item').forEach(function(el) {
          el.classList.remove('is-selected');
        });
        clearMobilePlacementHints();
        render();
      };
      hint.addEventListener("touchend", placeHandler, { passive: false });
      hint.addEventListener("click", placeHandler);
      grid.appendChild(hint);
    }
    return;
  }

  const isShelf = def.height === 0.5;
  const startR = isShelf ? 0.5 : 0;
  const step = isShelf ? 1 : 1;
  for (let r = startR; r <= state.height - def.height; r += step) {
    for (let c = 0; c <= state.width - def.width; c++) {
      if (canPlaceAt(r, c, def.width, def.height, -1, def.id)) {
        const hint = mk("div", `position:absolute;
          left:${c * CELL + 2}px;
          top:${r * CELL + 2}px;
          width:${def.width * CELL - 4}px;
          height:${def.height * CELL - 4}px;
          background: rgba(74, 158, 255, 0.10);
          outline: 2px dashed rgba(74, 158, 255, 0.55);
          outline-offset: -2px;
          border-radius: 4px;
          z-index: 25;
          cursor: pointer;
          touch-action: manipulation;
          mix-blend-mode: multiply;`,
          { className: "mona-cell-hint" });
        const targetRow = r;
        const targetCol = c;
        const placeHandler = function(e) {
          e.stopPropagation();
          e.preventDefault();
          addModule(def.id, targetRow, targetCol);
          state.selectedModuleId = null;
          window.MONA_PENDING_PLACEMENT = null;
          document.querySelectorAll('.mona-mobile-library-item').forEach(function(el) {
            el.classList.remove('is-selected');
          });
          clearMobilePlacementHints();
          render();
        };
        hint.addEventListener("touchend", placeHandler, { passive: false });
        hint.addEventListener("click", placeHandler);
        grid.appendChild(hint);
      }
    }
  }
}

(function initMobileLibraryStrip() {
  if (window.innerWidth > 960) return;
  const shell = document.querySelector(".mona-canvas-shell");
  if (!shell) return;
  if (document.getElementById("mona-mobile-library-strip")) return;

  const strip = mk("div", null, { className: "mona-mobile-library-strip", id: "mona-mobile-library-strip" });
  shell.appendChild(strip);

  const badge = document.getElementById("mona-dimensions-badge");
  const builder = shell.querySelector(".mona-builder");
  if (badge && builder) {
    badge.style.position = "absolute";
    badge.style.top = "auto";
    badge.style.bottom = "4px";
    badge.style.right = "8px";
    badge.style.zIndex = "50";
    builder.appendChild(badge);
    builder.style.position = "relative";
  }

  function renderStrip() {
    strip.innerHTML = "";
    moduleDefs.forEach(def => {
      const thumbImg   = def.thumbnail || def.image || "";
      const priceLabel = currency.ready ? money(getDisplayPrice(def.price || 0)) : "…";
      const item = mk("div", null, { className: "mona-mobile-library-item" });
      item.innerHTML = `
        <div class="mona-mobile-library-item-img">
          ${thumbImg ? `<img src="${thumbImg}" alt="${def.name}">` : ""}
        </div>
        <div class="mona-mobile-library-item-name">${def.name}</div>
        <div class="mona-mobile-library-item-price">${priceLabel}</div>
      `;
      item.addEventListener("click", () => {
        document.querySelectorAll('.mona-move-hint').forEach(el => el.remove());
        if (window.MONA_PENDING_PLACEMENT && window.MONA_PENDING_PLACEMENT.typeId === def.id) {
          window.MONA_PENDING_PLACEMENT = null;
          document.querySelectorAll('.mona-mobile-library-item').forEach(function(el) {
            el.classList.remove('is-selected');
          });
          clearMobilePlacementHints();
          setStatus(T("status_selection_cleared", "Selection cleared."));
          return;
        }
        window.MONA_PENDING_PLACEMENT = { typeId: def.id, def: def };
        document.querySelectorAll('.mona-mobile-library-item').forEach(function(el) {
          el.classList.remove('is-selected');
        });
        item.classList.add('is-selected');
        setStatus(T("status_tap_to_place", "Tap a cell to place {{ name }}.").replace("{{ name }}", def.name));
        renderMobilePlacementHints(def);
      });
      strip.appendChild(item);
    });
  }

  renderStrip();
  const interval = setInterval(() => {
    if (currency.ready) {
      renderStrip();
      clearInterval(interval);
    }
  }, 500);
})();

[
  "#mona-knob-group",
  ".mona-summary-card",
  ".mona-help",
  ".mona-head p"
].forEach(sel => {
  app.querySelectorAll(sel).forEach(el => { el.style.display = "none"; });
});

window.MONA_STATE = state;
window.MONA_APPLY_TRANSFORM = applyTransform;
window.MONA_CLEAR_SELECTION = clearSelection;
window.MONA_RENDER_PLACEMENT_HINTS = renderMobilePlacementHints;
window.MONA_GET_MODULE_DEF = getModuleDef;
window.MONA_RENDER = render;
window.MONA_ENCODE_STATE = encodeBuildState;

const restoredFromURL = loadBuildStateFromURL();
if (!restoredFromURL) clampDimensions();

initToolColumn();
setRightPanelMode("customize");
fetchExchangeRate();

requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    render();
    setStatus(restoredFromURL ? T("status_config_restored", "Configuration restored.") : T("status_ready", "Ready."));

    /* Mobile Safari fails to commit transform-style: preserve-3d on first
       paint when images are still loading or when the intro modal is about
       to open. The fix: detach + reattach the wrapper to force a fresh
       layout pass with 3D enabled. We run this at multiple trigger points
       to catch various race conditions — at least one will land after
       images have loaded and layout has stabilized. */
    function force3DRender() {
      if (!els.gridWrapper) return;
      const wrapper = els.gridWrapper;
      const parent = wrapper.parentNode;
      if (!parent) return;
      const next = wrapper.nextSibling;
      parent.removeChild(wrapper);
      void parent.offsetHeight;
      if (next) parent.insertBefore(wrapper, next);
      else parent.appendChild(wrapper);
      requestAnimationFrame(() => {
        applyTransform();
        const origRotY = state.rotY;
        state.rotY = origRotY + 0.5;
        applyTransform();
        setTimeout(() => {
          state.rotY = origRotY;
          applyTransform();
        }, 30);
      });
    }
    window.MONA_FORCE_3D = force3DRender;

    /* COLD-LOAD FIX: the timer-based retries below can all fire before the
       module box images have finished decoding on a first (uncached) load.
       When that happens iOS Safari commits the wrapper as 2D and never
       recovers until a refresh (when images are cached). So: explicitly wait
       for every <img> currently inside the grid to finish loading, then force
       a 3D recompute. This lands reliably on the true stable state. */
    function force3DAfterImages() {
      if (!els.grid) { force3DRender(); return; }
      const imgs = Array.from(els.grid.querySelectorAll('img'));
      if (imgs.length === 0) { force3DRender(); return; }
      let remaining = imgs.length;
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        /* One frame after the last image settles, force the 3D pass. */
        requestAnimationFrame(() => {
          force3DRender();
          setTimeout(force3DRender, 60);
        });
      };
      const tick = () => { remaining--; if (remaining <= 0) finish(); };
      imgs.forEach(img => {
        if (img.complete && img.naturalWidth > 0) { tick(); return; }
        img.addEventListener('load',  tick, { once: true });
        img.addEventListener('error', tick, { once: true });
      });
      /* Hard timeout so a single stuck image can't block the fix forever. */
      setTimeout(finish, 2500);
    }
    if (window.innerWidth <= 960) {
      force3DAfterImages();

      /* Real fix for the cold-load 2D bug: most module faces are CSS
         background-image on divs, not <img> tags, so force3DAfterImages()
         can't actually detect when they've loaded — it was resolving before
         the real assets arrived on a slow/cold connection. Wait on the
         actual preload promise (tracks every unique CDN image used across
         all box types) and re-run the 3D fix once they're truly done. */
      if (window.MONA_ASSETS_LOADED && typeof window.MONA_ASSETS_LOADED.then === 'function') {
        window.MONA_ASSETS_LOADED.then(function() {
          requestAnimationFrame(function() { requestAnimationFrame(force3DRender); });
        });
      }

      /* Belt-and-suspenders: the first time the user interacts with the canvas
         on mobile, force a 3D recompute. By then images are loaded and the
         modal is gone, so this always lands. Runs once. */
      const shell = document.querySelector('.mona-canvas-shell');
      if (shell) {
        const kick = () => {
          force3DRender();
          shell.removeEventListener('touchstart', kick);
          shell.removeEventListener('pointerdown', kick);
        };
        shell.addEventListener('touchstart', kick, { passive: true });
        shell.addEventListener('pointerdown', kick, { passive: true });
      }

      /* Multi-stage retry: catches both fast (cached refresh) and slow
         (first load with image fetches in flight) cases. */
      [200, 800, 1800, 3500].forEach(delay => setTimeout(force3DRender, delay));

      /* When all images/resources are done, re-trigger once more. This is
         the key fix for first-load: on a cold load, the 200ms attempt fires
         before module images have loaded; this catches the stable state. */
      if (document.readyState === 'complete') {
        setTimeout(force3DRender, 80);
      } else {
        window.addEventListener('load', () => setTimeout(force3DRender, 80));
      }
    }

    /* The intro modal opening (at 600ms) and closing both cause viewport /
       compositing state changes on iOS Safari that can desync the 3D layer.
       Watch its visibility and re-fix whenever it closes. */
    const introModal = document.getElementById('mona-intro-modal');
    if (introModal) {
      const introObserver = new MutationObserver(() => {
        if (!introModal.classList.contains('is-open')) {
          /* Modal just closed — the canvas was occluded during the earlier
             force3DRender retries, so re-run several times now that it's
             actually visible. */
          [60, 250, 600, 1200].forEach(d => setTimeout(force3DRender, d));
        }
      });
      introObserver.observe(introModal, { attributes: true, attributeFilter: ['class'] });
    }
  });
});

try {
  if (sessionStorage.getItem('mona_open_cart_after_reload') === '1') {
    sessionStorage.removeItem('mona_open_cart_after_reload');
    setTimeout(() => {
      const drawer = document.querySelector('dialog.cart-drawer__dialog, cart-drawer, [id*="cart-drawer"], .cart-drawer, dialog[class*="cart-drawer"]');
      if (drawer) {
        if (typeof drawer.showModal === 'function') { try { drawer.showModal(); return; } catch (e) {} }
        if (typeof drawer.show === 'function') { drawer.show(); return; }
        if (typeof drawer.open === 'function') { drawer.open(); return; }
      }
      const cartBtn = document.querySelector('button[data-testid="cart-toggle"], button[aria-label*="cart" i], a[href="/cart"], a[href*="/cart"]');
      if (cartBtn) cartBtn.click();
    }, 300);
  }
} catch (e) {}